// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T18:40:01.244Z
// Property: FLATZ 480 (ID: 6767906449167811)
// Collections: 45 amenities, 9 floorplans (live), 14 photos, 74 POIs, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162477",
  "multihub_property_id": "6767906449167811",
  "property_external_id": "2548688",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/san-tan-valley-az/pool/",
  "property_google_business_url": "https://www.google.com/maps/place/FLATZ+480/@33.2423625,-111.561897,957m/data=!3m2!1e3!4b1!4m6!3m5!1s0x872a4bd4f6d7a341:0x6bd08b11c18ea947!8m2!3d33.2423625!4d-111.561897!16s%2Fg%2F11nw1q3ryd!5m1!1e2?entry=ttu&g_ep=EgoyMDI2MTAxMS4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "58853813423",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "Property ID: 2548688 | Property Code: p2535846",
  "property_status": null,
  "property_slug": "flatz-480",
  "property_name": "FLATZ 480",
  "property_website_url": "https://www.flatz480.com/",
  "property_domain": "https://www.flatz480.com/",
  "property_address": "133 E El Parque Ln",
  "property_full_address": "133 E El Parque Ln, San Tan Valley, AZ 85140",
  "property_address_1": "133 E El Parque Ln",
  "property_address_2": null,
  "property_address_city": "San Tan Valley",
  "property_address_state": "AZ",
  "property_address_zip_full": "85140",
  "property_address_zip": "85140",
  "property_address_country": "US",
  "property_address_county": "Pinal County",
  "property_neighborhood_address": null,
  "property_address_latitude": "33.2423625",
  "property_address_longitude": "-111.561897",
  "property_email": "Manager@FLATZ480.com",
  "property_phone": "(480) 745-1212",
  "property_call_tracking_phone": "480-903-3888",
  "property_company_name": "Z Modular",
  "property_company_url": "https://www.z-modular.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Better-built San Tan Valley living starts at FLATZ 480.</strong> Explore polished studio to three-bedroom apartments with quartz countertops, stainless steel appliances, in-home laundry, and private outdoor space—then view <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_long_description": "<p><strong>Better-built San Tan Valley living starts at FLATZ 480.</strong> Choose a studio, one-, two-, or three-bedroom apartment with the finishes that make home feel polished from day one: quartz countertops, stainless steel appliances, vinyl plank flooring, soft-close cabinetry, in-home laundry, ceiling fans, and a balcony or patio for desert evenings.</p><p>Outside your door, the community is built for momentum and downtime alike. Start the morning in the 24-hour fitness center or CoWork Studio, meet in the private conference room, cool off at the <a href=\"/amenities\">resort-style pool</a> and hot tub, then unwind by the fire pit, grilling station, event lawn, pickleball court, bocce area, or multi-sport simulator room. Dog parks, EV charging, package lockers, high-speed bulk Wi-Fi, covered parking, and door-to-door trash pickup keep the details easy.</p><p>Set near the Queen Creek/San Tan Valley corridor, you’re close to shopping and dining at Queen Creek Marketplace, farm-fresh stops at Schnepf Farms and Queen Creek Olive Mill, and desert trails at San Tan Mountain Regional Park. Explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a16522-bedb-70cc-909a-413397290325.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a modern apartment complex with colorful facade and balconies, walkways, and parking lot.",
    "public_id": "01a16522-bedb-70cc-909a-413397290325",
    "storage_key": "property/6767906449167811/01a16522-bedb-70cc-909a-413397290325.webp",
    "width": 3072,
    "height": 1728
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": "200",
  "property_application_fee": null,
  "property_fees_deposit_info": "Security deposit: $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of two (2) pets per home; no weight limit or breed restrictions.",
  "property_pet_policy_description": "FLATZ 480 is a pet‑friendly community! There is no weight limit or breed restrictions, but we do have a maximum of two (2) pets per home. We use a service called PetScreening for all of our residents to complete a pet profile, a “no‑pet” profile, or request accommodation for an assistance or service animal. PetScreening is a part of the application process for all of our residents.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://flatz480.securecafeapplicant.com/onlineleasing/content3/access/flatz-480/floorplans",
  "property_resident_portal_url": "https://flatz480.securecafenet.com/residentservices/flatz-480/userlogin",
  "property_apply_now_url": "https://flatz480.securecafeapplicant.com/onlineleasing/content3/access/flatz-480/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cc-0244-71ba-a277-c1c900636da0.webp",
  "property_primary_logo_media": {
    "alt_text": "FLATZ 480 logo",
    "public_id": "01a117cc-0244-71ba-a277-c1c900636da0",
    "storage_key": "property/6767906449167811/01a117cc-0244-71ba-a277-c1c900636da0.webp",
    "width": 825,
    "height": 210
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a13b1e-4385-776c-98e3-91d9c738ccac.webp",
  "property_secondary_logo_media": {
    "alt_text": "FLATZ 480 logo",
    "public_id": "01a13b1e-4385-776c-98e3-91d9c738ccac",
    "storage_key": "property/6767906449167811/01a13b1e-4385-776c-98e3-91d9c738ccac.webp",
    "width": 541,
    "height": 287
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13b82-360e-700b-a136-440b6b7cfdcf.webp",
  "property_fav_icon_media": {
    "alt_text": "Red and brown Z logo",
    "public_id": "01a13b82-360e-700b-a136-440b6b7cfdcf",
    "storage_key": "company/5767906449162477/01a13b82-360e-700b-a136-440b6b7cfdcf.webp",
    "width": 1080,
    "height": 1080
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cc-2928-764d-b0f7-9e6f9beb469c.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a117cc-2928-764d-b0f7-9e6f9beb469c",
    "storage_key": "property/6767906449167811/01a117cc-2928-764d-b0f7-9e6f9beb469c.webp",
    "width": 825,
    "height": 210
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cc-1d69-76c8-9c77-d79c4295c2b2.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a117cc-1d69-76c8-9c77-d79c4295c2b2",
    "storage_key": "property/6767906449167811/01a117cc-1d69-76c8-9c77-d79c4295c2b2.webp",
    "width": 825,
    "height": 210
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13b82-360e-700b-a136-440b6b7cfdcf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13aed-a1b4-75fa-8eea-2a352ae0cd0e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13aed-9f9c-7250-a571-60b30bf57b15.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162477/01a13aed-a0ab-7569-bf2b-4298ffba6543.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#6e776d",
  "property_secondary_color": "#363a35",
  "property_font_color": "#363a35",
  "property_color_4": "#af7558",
  "property_color_3": "#363a35",
  "property_color_5": "#af7558",
  "property_color_6": "#c59a7b",
  "property_color_7": "#e51837",
  "property_color_8": "#931903",
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "568 - 568",
  "property_sqft_min": "568",
  "property_sqft_max": "568",
  "property_price_range": "$1254 - $1254",
  "property_price_min": "1254",
  "property_price_max": "1254",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/people/FLATZ-480/61587690021719/",
  "property_instagram_url": "https://www.instagram.com/flatz480",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJQaPX9tRLKocRR6mOwRGL0Gs",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to FLATZ 480",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "<p><strong>Amenities that keep the day moving.</strong> At FLATZ 480, shift from the CoWork Studio and private conference room to a 24-hour fitness center, resort-style pool, hot tub, and social suite. Add a multi-sport simulator, pickleball, bocce, fire pit, grilling station, EV charging, dog parks, and apartment finishes like quartz countertops, stainless steel appliances, in-home laundry, and private outdoor space—and the everyday details feel easy from the start.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room for your routine.</strong><br>Choose from studio, one-, two-, and three-bedroom apartments at FLATZ 480, each with open living space, quartz countertops, stainless steel appliances, vinyl plank flooring, and an in-home washer and dryer. Select the plan that fits your space needs, then enjoy polished details like soft-close cabinetry, open-concept closets, double-insulated walls, and a private balcony or patio.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview life at FLATZ 480.</strong> Flip through bright kitchens with quartz-topped islands, stainless steel appliances, soft-close cabinetry, and vinyl plank flooring that flows into open living spaces. Then picture the pace beyond your door: a resort-style pool and hot tub, fire pit seating, clubhouse games, a multi-sport simulator, and focused space in the CoWork Studio.</p>",
  "property_home_neighborhood_blurb": "<p><strong>East Valley days start close to home.</strong> Grab coffee or run errands at Queen Creek Marketplace, head to Pecan Lake Entertainment for arcade games, BBQ, mini golf, and lake views, or unwind at Mansel Carter Oasis Park with trails, courts, and open desert sky. With the San Tan foothills, Phoenix-Mesa Gateway Airport, and the Mesa/Gilbert corridor within reach, FLATZ 480 keeps your map wide open.</p>",
  "property_home_reviews_blurb": "<p><strong>See what stands out at FLATZ 480.</strong> Resident feedback offers a real-life look at the apartments, shared spaces, service experiences, and everyday impressions that shape the community. Browse highlighted reviews, then explore the full page for more perspectives as you compare photos, tours, and floor plans.</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the map, then make the neighborhood your own.</strong> From FLATZ 480, your day can move from coffee and errands around Queen Creek Marketplace to arcade games, BBQ, mini golf, and lake views at Pecan Lake Entertainment. Stretch out at Mansel Carter Oasis Park, where trails, sport courts, a fishing lake, and open desert sky give the area its easy East Valley pace. When you want a bigger reset, the San Tan foothills are close enough for a sunset hike, while Phoenix-Mesa Gateway Airport and the Mesa/Gilbert corridor keep regional connections within reach. After exploring, come back to a gated community with spaces built for unwinding—preview them on the <a href=\"/amenities\">amenities page</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich without overcomplicating your day.</strong> At FLATZ 480, your routine has room to shift—from a focused session in the CoWork Studio or private conference room to a reset in the 24-hour fitness center, resort-style pool, or hot tub. When it’s time to unwind, the multi-sport simulator room, pickleball, bocce, fire pit, grilling station, and social suite create plenty of ways to stay close to home and still change the scenery.</p><p>Inside, your apartment keeps the same easy rhythm with quartz countertops, stainless steel appliances, soft-close cabinetry, vinyl plank flooring, in-home laundry, double-insulated walls, and a balcony or patio. Add package lockers, high-speed bulk Wi-Fi, EV charging, covered parking, and dog parks, and the details feel handled before you have to ask. Preview the spaces in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make FLATZ 480 home?</strong> Start your application online for a studio, one-, two-, or three-bedroom apartment with polished finishes like quartz countertops, stainless steel appliances, vinyl plank flooring, in-home laundry, and a balcony or patio—plus community spaces designed for everyday ease.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact the FLATZ 480 leasing team for details on available apartments, polished in-home finishes, community features, or directions to our San Tan Valley location. Ready to take the next step? Ask us anything or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_faqs_blurb": "<p><strong>Questions about FLATZ 480?</strong> Start here for quick answers on leasing, floor plans, everyday living, and community details. If you don’t see what you need, the leasing team is happy to help—just <a href=\"/contact-us\">contact us</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_floorplans_blurb": "<p><strong>Find the floor plan that fits your day.</strong><br>At FLATZ 480, you can start simple with a streamlined studio, stretch out in a one-bedroom, or choose a two- or three-bedroom layout with more room to spread, work, host, or recharge. Each apartment is designed to feel polished and practical, with open living areas, in-home washer and dryer, quartz countertops, stainless steel appliances, vinyl plank flooring, ceiling fans, and a balcony or patio that extends your space outdoors.</p><p>As you compare availability, look for the details that make daily life smoother: soft-close cabinetry, open-concept closets, full-size tub/shower combinations, and double-insulated walls for a more comfortable home base in San Tan Valley. Explore current layouts, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite plan in person.</p>",
  "property_gallery_blurb": "<p><strong>Let the photos do the walkthrough.</strong> Browse FLATZ 480’s gallery to see bright kitchens with quartz-topped islands, stainless steel appliances, soft-close cabinetry, and vinyl plank flooring that carries into open living spaces. Notice the small moments, too—ceiling fans over calm rooms, patios and balconies catching San Tan Valley light, and layouts that range from efficient studios to roomier three-bedroom homes.</p><p>Beyond your front door, the images shift from polished interiors to places made for changing the pace: a resort-style pool and hot tub, fire pit seating, clubhouse games, the multi-sport simulator, and focused corners for work in the CoWork Studio. When a photo catches your eye, explore the <a href=\"/virtual-tours\">virtual tours</a>, compare <a href=\"/floor-plans\">floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in motion.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Explore available apartments at FLATZ 480, then use the interactive map to see how the Queen Creek/San Tan Valley corridor connects you to nearby shopping, dining, farm-fresh stops, and desert trails.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living that feels easy from the first walk.</strong> At FLATZ 480, your pet has space to settle in without the usual size or breed fine print—just a clear two-pet limit and a simple PetScreening profile during the application process. Start the day with a stroll through the gated community, let your dog stretch out at the on-site dog parks, then head back to an apartment built for everyday cleanups with vinyl plank flooring, in-home laundry, and a balcony or patio for fresh air.</p><p>When you want to see how the pet-friendly perks fit into the bigger picture, browse the <a href=\"/amenities\">community amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to walk the spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share better-built San Tan Valley living.</strong> Love your polished apartment finishes, resort-style downtime, work-ready spaces, and everyday conveniences at FLATZ 480? Refer a friend and invite them to find their place here, too.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at FLATZ 480</strong><br>Keep the details easy from home. Log in to pay rent, submit maintenance requests, and manage your account—so you can get back to the polished San Tan Valley living, desert evenings, and built-in conveniences that make FLATZ 480 feel effortless.</p>",
  "property_reviews_blurb": "<p><strong>Hear it from the people who know FLATZ 480 firsthand.</strong> Your next home is a decision worth exploring from every angle, and resident reviews offer a helpful look at everyday life in the community.</p><p>Browse ratings and feedback in one place to see what stands out about the apartments, shared spaces, service experiences, and overall impressions. As you read, use these real perspectives alongside photos, tours, and floor plan details to decide whether FLATZ 480 feels like the right fit for what you’re looking for.</p>",
  "property_created_at": "1791400553224",
  "property_scheduletour_blurb": "<p><strong>See FLATZ 480 up close.</strong> Tour polished studio, one-, two-, or three-bedroom apartments with quartz countertops, stainless steel appliances, vinyl plank flooring, in-home laundry, and a balcony or patio. Then step into the community spaces built for work, workouts, relaxing, and desert evenings. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to FLATZ 480.</strong> Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture polished San Tan Valley living with quartz countertops, stainless steel appliances, in-home laundry, and inviting spaces designed for momentum and downtime.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. FLATZ 480",
  "property_seo_title_home": "FLATZ 480 |  Apartments in San Tan Valley, AZ",
  "property_seo_description_home": "Experience vibrant living at FLATZ 480 in San Tan Valley, AZ. With stunning floor plans and top-notch amenities, your dream home awaits! Reserve yours today!",
  "property_seo_title_floorplans": "Floor Plans | San Tan Valley, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at FLATZ 480 in San Tan Valley! From cozy studios to spacious three-bedroom layouts, browse our unique floor plans today.",
  "property_seo_title_amenities": "Amenities | San Tan Valley, AZ Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at FLATZ 480 in San Tan Valley! With top-notch amenities, including a resort pool and dog park, your dream home awaits.",
  "property_seo_title_gallery": "Gallery | Apartments in San Tan Valley, AZ",
  "property_seo_description_gallery": "Imagine life at FLATZ 480 in San Tan Valley, AZ! Enjoy stunning amenities, stylish floor plans, and a community vibe that feels like home. View our gallery!",
  "property_seo_title_virtualtours": "Virtual Tours | FLATZ 480 Apartments",
  "property_seo_description_virtualtours": "Step inside FLATZ 480 in San Tan Valley, AZ! Take a virtual tour of our stylish studio to three-bedroom apartments and envision your new lifestyle today!",
  "property_seo_title_interactivemap": "Interactive Map | FLATZ 480 Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at FLATZ 480 in San Tan Valley! Enjoy a resort-style lifestyle with spacious floor plans, modern amenities, and a vibrant community.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Tan Valley, AZ",
  "property_seo_description_neighborhood": "Uncover the charm of San Tan Valley! FLATZ 480 offers vibrant community life with nearby favorites. Find your perfect studio to three-bedroom home today!",
  "property_seo_title_contact": "Contact Us | FLATZ 480",
  "property_seo_description_contact": "Connect with FLATZ 480 in San Tan Valley, AZ! Inquire about our studio to three-bedroom options. Your ideal apartment awaits. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in San Tan Valley, AZ",
  "property_seo_description_faqs": "Uncover answers about FLATZ 480 in San Tan Valley! From apartment amenities to community perks, our FAQs page has all you need to know for your new home.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Tan Valley, AZ",
  "property_seo_description_reviews": "Discover FLATZ 480 in San Tan Valley, AZ! Enjoy our vibrant community, stylish floor plans, and unique amenities. Your new home awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in San Tan Valley, AZ",
  "property_seo_description_applynow": "Discover luxury living at FLATZ 480 in San Tan Valley, AZ! Unique floor plans, resort amenities, and a vibrant community await. Lease today!",
  "property_seo_title_residentaccess": "Resident Access | FLATZ 480",
  "property_seo_description_residentaccess": "Seamlessly manage your home at FLATZ 480! Log in to access rent payment, maintenance requests, and exclusive resident features in San Tan Valley, AZ.",
  "property_seo_title_referafriend": "Refer A Friend | FLATZ 480",
  "property_seo_description_referafriend": "Refer a friend to FLATZ 480 in San Tan Valley, AZ! Great friends make great neighbors—share the joy of upscale living and vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | FLATZ 480",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at FLATZ 480 in San Tan Valley, AZ. Schedule your personalized tour today and envision your new home!",
  "property_seo_title_privacy": "Privacy Policy | FLATZ 480",
  "property_seo_description_privacy": "Your privacy matters to us at FLATZ 480. Dive into our policy and understand how we protect your information while you enjoy life in San Tan Valley, AZ.",
  "property_seo_title_accessibility": "Website Accessibility | FLATZ 480",
  "property_seo_description_accessibility": "At FLATZ 480 in San Tan Valley, we champion digital inclusion. Learn how our community ensures accessibility for everyone to thrive and connect seamlessly.",
  "property_seo_title_sitemap": "Sitemap | FLATZ 480",
  "property_seo_description_sitemap": "Unravel the charm of FLATZ 480 in San Tan Valley, AZ! Navigate our sitemap to find your dream home and community amenities that elevate your lifestyle.",
  "property_seo_title_thankyou": "Thank You | FLATZ 480",
  "property_seo_description_thankyou": "Thanks for reaching out to FLATZ 480! Your inquiry is in good hands—and we can’t wait to help you find your perfect home in San Tan Valley.",
  "property_seo_title_pets": "Pet Policy | Apartments in San Tan Valley, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793722546652",
  "amenities": [
    {
      "id": "ec_cbc4782dd839bd6655f201ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479922",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d3527356dd0daf947fa3326",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479907",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a385a507c7a0c238a4208b3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479894",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2672ef820b61fe44d1e971a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479895",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62201a5202698e57e072fc64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479889",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02885af0df89e0ee3a861539",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479887",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31947af16a4a3c302bfbc84a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479888",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b9a971472e4ea414605a6c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128478887",
      "title": "Grilling Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b39aeeabded5e84d8ba1be8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479832",
      "title": "Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f17ae8047e1fa0090848d02e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479834",
      "title": "Muti-Sport Simulator Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7c5bcf1b722b0971cdd2387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479837",
      "title": "Clubhouse: TV & Games Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bbd56efff105af4ff198d8bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479839",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_505574d0bf5853a893fe684d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479840",
      "title": "Pet Fountain",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a97aea605690a9f1094b4643",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479841",
      "title": "Resort-Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e57c8150451c2284a26aa36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479896",
      "title": "Double-Insulated Walls",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71742795a16ea8eec7eb5e6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479842",
      "title": "Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a27bf3e4a772a1366890cb33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479843",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3bd9cd9078fc3cd040da7ffe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479902",
      "title": "In-Home Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fdaf634a882a6119372bcfdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479903",
      "title": "Full Size Tub/Shower Combo",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f799dbdc8bde8f5cfd72a9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479844",
      "title": "Private Conference Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7b001d4bdfe003d400e45d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479904",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_271ed222c01c412719e2cfe0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479846",
      "title": "Social Suite w/ Kitchenette",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_617e16e37106cd9919a066e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479905",
      "title": "Living Room & Bedroom Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_789b3b86919d70517590a3d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479847",
      "title": "Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0ab6d20a022fa55ed08c905",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479908",
      "title": "Ductless Mini Split",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c0c7d7bcbe02b60b0e1effc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479848",
      "title": "High Speed Bulk Wifi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_092737cd1e8350e1e314eefd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479849",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5db437786eb611c01f7e28fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479909",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_082e29b1a1554226d749bfea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479850",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99dd2f851d594429701fcde1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479910",
      "title": "Vinyl Plank Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d62441527a2f10e301a12b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479918",
      "title": "Open Concept Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4265498adb6d7288d257c58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479851",
      "title": "Reserved & Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e0d60d5afdb32f438ecad97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479852",
      "title": "EV Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_109a6ac6ce26ad725cdbfe2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479919",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13bcc6167429d7c7d4a23a1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479853",
      "title": "Door to Door Trash Pickup",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3e3b75fb1a4b3d835f60cd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479921",
      "title": "Soft Close Cabinets & Drawers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efb6f54c01d2e6d77a5933e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479854",
      "title": "Community Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85c7afb7e735146195a93fd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479859",
      "title": "Pickleball",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d243d48436f75d383ffedfbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479860",
      "title": "Bocce Ball",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cef9b5e308adbd4d535f2834",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479867",
      "title": "Bike Racks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3f8c1518766572d10294008",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479868",
      "title": "Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_740bbd4dcb87b248d3135313",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479873",
      "title": "Event Lawn",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d214126cabc968dbf917e12e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479874",
      "title": "Outdoor Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97c40e2d973ce9247751d00c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479878",
      "title": "Trash Enclosure",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91fdd8010969a827b53ce3dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "128479879",
      "title": "Community Garden",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_72bec93a-7f74-40e5-a320-244bf764bd7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cc-00d5-7482-86fc-8396685def9a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, tables, umbrellas, and a fire pit.",
        "public_id": "01a117cc-00d5-7482-86fc-8396685def9a",
        "storage_key": "property/6767906449167811/01a117cc-00d5-7482-86fc-8396685def9a.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, relax in the sun on comfortable lounge chairs, or gather with friends around the cozy fire pit.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, tables, umbrellas, and a fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b262cfea-e74a-4c0f-84d6-1137948ef6b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-f753-77ba-a000-6ef261e7b5e4.webp",
      "image_media": {
        "alt_text": "Indoor golf simulator and sports room with golf clubs and balls",
        "public_id": "01a117cb-f753-77ba-a000-6ef261e7b5e4",
        "storage_key": "property/6767906449167811/01a117cb-f753-77ba-a000-6ef261e7b5e4.webp",
        "width": 800,
        "height": 500
      },
      "title": "Community",
      "description": "Practice your swing in our state-of-the-art indoor golf simulator, complete with a putting green and a variety of sports equipment for all residents to enjoy.",
      "link": "",
      "alt_text": "Indoor golf simulator and sports room with golf clubs and balls",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e978e4e-f058-4d94-a797-e3b7f9ad84c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-f5a0-70bf-8d57-10f29c400c28.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a queen-size bed, nightstands, and a window.",
        "public_id": "01a117cb-f5a0-70bf-8d57-10f29c400c28",
        "storage_key": "property/6767906449167811/01a117cb-f5a0-70bf-8d57-10f29c400c28.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Apartment",
      "description": "Cozy primary bedroom featuring a comfortable queen-size bed, elegant nightstands with lamps, and a large window with blinds, offering a bright and airy ambiance.",
      "link": "",
      "alt_text": "Primary bedroom with a queen-size bed, nightstands, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_49be800a-2857-4965-adb2-4ebf877dc007",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-f506-7638-a8c6-f3dd897fcb09.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with high-top tables and stools, overlooking an outdoor patio with umbrellas and seating.",
        "public_id": "01a117cb-f506-7638-a8c6-f3dd897fcb09",
        "storage_key": "property/6767906449167811/01a117cb-f506-7638-a8c6-f3dd897fcb09.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Community",
      "description": "Enjoy a vibrant communal lounge perfect for socializing or working. This space features comfortable seating and large windows with views of the property's outdoor amenities.",
      "link": "",
      "alt_text": "Modern communal lounge area with high-top tables and stools, overlooking an outdoor patio with umbrellas and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd5dd00d-b922-4056-8aa0-bf969e4399ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-f542-7449-8b4d-19d23a8567c2.webp",
      "image_media": {
        "alt_text": "Living room with TV, coffee table, blue armchair, and view into bedroom.",
        "public_id": "01a117cb-f542-7449-8b4d-19d23a8567c2",
        "storage_key": "property/6767906449167811/01a117cb-f542-7449-8b4d-19d23a8567c2.webp",
        "width": 800,
        "height": 500
      },
      "title": "Apartment",
      "description": "Chic and modern living room featuring a large flat-screen TV, a unique wood slab coffee table, and a comfortable blue armchair. The open doorway reveals a glimpse of a well-appointed bedroom.",
      "link": "",
      "alt_text": "Living room with TV, coffee table, blue armchair, and view into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8631f96-b728-471c-b014-e18d8fbe7020",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-ef8d-77d0-ba58-3af2094aa918.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with bar stools.",
        "public_id": "01a117cb-ef8d-77d0-ba58-3af2094aa918",
        "storage_key": "property/6767906449167811/01a117cb-ef8d-77d0-ba58-3af2094aa918.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish, modern kitchen featuring dark wood cabinetry, sleek countertops, and stainless steel appliances. The spacious island with bar seating is perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c1bccc7c-1845-4cae-beb2-737ed5e1d5bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-ec43-73c1-87a7-28cecd1f4d47.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, red Adirondack chairs, and pergolas.",
        "public_id": "01a117cb-ec43-73c1-87a7-28cecd1f4d47",
        "storage_key": "property/6767906449167811/01a117cb-ec43-73c1-87a7-28cecd1f4d47.webp",
        "width": 1800,
        "height": 700
      },
      "title": "Community",
      "description": "Relax and unwind by our beautiful outdoor swimming pool, featuring comfortable lounge seating, cabanas, and vibrant Adirondack chairs. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, red Adirondack chairs, and pergolas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_81c6e293-da00-4763-a8f0-7f75ca7d5cfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e8cd-73cf-b1bc-6335f775c91f.webp",
      "image_media": {
        "alt_text": "Balcony view of apartment exterior with a potted plant and a glimpse into the living room.",
        "public_id": "01a117cb-e8cd-73cf-b1bc-6335f775c91f",
        "storage_key": "property/6767906449167811/01a117cb-e8cd-73cf-b1bc-6335f775c91f.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Enjoy your private balcony with a lovely view, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Balcony view of apartment exterior with a potted plant and a glimpse into the living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4882ab63-7d94-45e8-a586-4a31a92a04ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a15635-7524-759a-b52d-ffede6b41cf9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "01a15635-7524-759a-b52d-ffede6b41cf9",
        "storage_key": "property/6767906449167811/01a15635-7524-759a-b52d-ffede6b41cf9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Discover a chef's dream kitchen, featuring sleek dark wood cabinetry, premium stainless steel appliances, and elegant quartz countertops for a sophisticated cooking experience.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_af785b7f-9de9-4b18-893c-853704f0188e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a15634-9594-716d-9eb1-335ac461d294.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a15634-9594-716d-9eb1-335ac461d294",
        "storage_key": "property/6767906449167811/01a15634-9594-716d-9eb1-335ac461d294.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, sleek stainless steel appliances, a deep sink, and a spacious island perfect for casual dining or entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and an island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_183fce0c-4682-462d-9e60-7053b9141cc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e8c0-72fe-97ae-2fe3a5aa828e.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a window.",
        "public_id": "01a117cb-e8c0-72fe-97ae-2fe3a5aa828e",
        "storage_key": "property/6767906449167811/01a117cb-e8c0-72fe-97ae-2fe3a5aa828e.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "A serene bedroom featuring a comfortable king-size bed, elegant nightstands with lamps, and a large window allowing natural light to flood the space.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_88e700d5-37ef-4075-bc38-9a8810f52e6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e116-74fe-8c56-ca12fa102205.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, walk-in closet, and en-suite bathroom.",
        "public_id": "01a117cb-e116-74fe-8c56-ca12fa102205",
        "storage_key": "property/6767906449167811/01a117cb-e116-74fe-8c56-ca12fa102205.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a king-size bed, ample closet space, and a modern en-suite bathroom.",
      "link": "",
      "alt_text": "Spacious bedroom with a king-size bed, walk-in closet, and en-suite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eda15867-fa9c-4213-a71a-277255cf87cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e1b7-74d8-b871-ea016e873fd5.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa and a balcony view.",
        "public_id": "01a117cb-e1b7-74d8-b871-ea016e873fd5",
        "storage_key": "property/6767906449167811/01a117cb-e1b7-74d8-b871-ea016e873fd5.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, modern decor, and access to a private balcony with scenic views.",
      "link": "",
      "alt_text": "Living room with a sectional sofa and a balcony view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ed8371bf-02c8-4ef1-9f5c-5dc656ab7b2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-e045-70e8-bcfe-44b971cf71de.webp",
      "image_media": {
        "alt_text": "Modern living room with a grey sectional sofa, coffee tables, and an open-concept kitchen.",
        "public_id": "01a117cb-e045-70e8-bcfe-44b971cf71de",
        "storage_key": "property/6767906449167811/01a117cb-e045-70e8-bcfe-44b971cf71de.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious living area seamlessly connected to a modern kitchen, featuring sleek cabinetry, stainless steel appliances, and a breakfast bar. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern living room with a grey sectional sofa, coffee tables, and an open-concept kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_21e11d37-16a8-46c9-8084-cf426bad6ff3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Moreno's Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "85 W Combs Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Basic counter-serve branch of a local chain with Sonoran hot dogs & other south-of-the-border eats.",
      "poi_long_description": "Basic counter-serve branch of a local chain with Sonoran hot dogs & other south-of-the-border eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-5d70-71f9-93ec-35b6ebfd4022.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-5d70-71f9-93ec-35b6ebfd4022",
        "storage_key": "property/6767906449167811/01a117cd-5d70-71f9-93ec-35b6ebfd4022.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://morenosmexicangrillaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12818154927246909870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morenos-mexican-grill",
      "poi_latitude": "33.2182594",
      "poi_longitude": "-111.564759",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-358-4642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqsaxK4cRrqF5Kv4747E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0919a25c-6af1-4365-9404-05afcd1a4859",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Cafe Rio Fresh Modern Mexican",
      "poi_type": "Restaurants",
      "poi_address": "611 E Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Counter-serve eatery dishing up Mexican classics including hand-rolled tortillas, burritos & tacos.",
      "poi_long_description": "Counter-serve eatery dishing up Mexican classics including hand-rolled tortillas, burritos & tacos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-5e9d-7128-98f5-3060f537890b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-5e9d-7128-98f5-3060f537890b",
        "storage_key": "property/6767906449167811/01a117cd-5e9d-7128-98f5-3060f537890b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.caferio.com/locations/johnson-ranch",
      "poi_directions_map_url": "https://maps.google.com/?cid=3234864438036539679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-rio-fresh-modern-mexican",
      "poi_latitude": "33.1587335",
      "poi_longitude": "-111.561579",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-257-7524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlxs323xJKocRHym2PRGM5Cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_61a6b797-9016-447b-8ca6-582c10ceb470",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Savvy’s Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "270 E Hunt Hwy #20, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Local sports bar featuring pub-style comfort food, signature burgers, and various appetizers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-5dc4-7090-b2ad-06f125bcd20c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-5dc4-7090-b2ad-06f125bcd20c",
        "storage_key": "property/6767906449167811/01a117cd-5dc4-7090-b2ad-06f125bcd20c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://savvysbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9021130910829558372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savvys-bar-and-grill",
      "poi_latitude": "33.1630573",
      "poi_longitude": "-111.5628962",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-867-1816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948a-72db-81b4-ce46cb2f1d37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948a-72db-81b4-ce46cb2f1d37",
        "storage_key": "property/6767906449167811/01a117cd-948a-72db-81b4-ce46cb2f1d37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZjsChxJKocRZLpKdMR-MX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_6858afe3-852b-4b6d-abd2-e8ab778856a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Bobo China",
      "poi_type": "Restaurants",
      "poi_address": "270 E Hunt Hwy #8, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Modest counter serve dishing out traditional Chinese cuisine in an informal strip-mall space.",
      "poi_long_description": "Modest counter serve dishing out traditional Chinese cuisine in an informal strip-mall space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-5868-758e-830e-d57b02324a16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-5868-758e-830e-d57b02324a16",
        "storage_key": "property/6767906449167811/01a117cd-5868-758e-830e-d57b02324a16.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://eatbobochina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5770315668760031018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bobo-china",
      "poi_latitude": "33.163513",
      "poi_longitude": "-111.5630746",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-888-2288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSw_yHy5JKocRKu9PPodHFFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_6f8d9100-8deb-421c-85d4-55c6a4109b27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Greek Islands Grill",
      "poi_type": "Restaurants",
      "poi_address": "270 E Hunt Hwy #9, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Straightforward Greek food plus burgers & hot dogs fill the menu at this counter-serve cafe.",
      "poi_long_description": "Straightforward Greek food plus burgers & hot dogs fill the menu at this counter-serve cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-5d27-74e8-b291-c7892d05df7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-5d27-74e8-b291-c7892d05df7a",
        "storage_key": "property/6767906449167811/01a117cd-5d27-74e8-b291-c7892d05df7a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.greekislandsgrillaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10829320480404885175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greek-islands-grill",
      "poi_latitude": "33.1635633",
      "poi_longitude": "-111.5629877",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-655-5454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzWPO8rVOKocRt05lyZl5SZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_06b10ba4-c404-46f9-a67a-b72f3bb8293b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Biscuits Cafe",
      "poi_type": "Restaurants",
      "poi_address": "270 E Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Low-key chain venue offering familiar American fare for breakfast & lunch, plus free WiFi.",
      "poi_long_description": "Low-key chain venue offering familiar American fare for breakfast & lunch, plus free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-5999-74de-ac71-454bb216f9fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-5999-74de-ac71-454bb216f9fc",
        "storage_key": "property/6767906449167811/01a117cd-5999-74de-ac71-454bb216f9fc.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.biscuitscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12108622772389182946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biscuits-cafe",
      "poi_latitude": "33.1624413",
      "poi_longitude": "-111.5636955",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-987-5217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4xwKFC5JKocR4n1220F4Cqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_9dde2673-fe7a-431b-b1c0-94863de5bd47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Chen's Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "530 E Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Generous portions of standard Chinese dishes are offered at this simple, unassuming eatery.",
      "poi_long_description": "Generous portions of standard Chinese dishes are offered at this simple, unassuming eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-589c-7661-b6e8-6d8d43bf7b55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-589c-7661-b6e8-6d8d43bf7b55",
        "storage_key": "property/6767906449167811/01a117cd-589c-7661-b6e8-6d8d43bf7b55.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://chenschineseaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12355909438741323067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chens-chinese-restaurant",
      "poi_latitude": "33.1613496",
      "poi_longitude": "-111.5603577",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-882-9133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xO4Di9JKocRO50SjSsCeas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_fa2ebac4-e38c-4822-bd75-9c99a9c78a72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Maddie Jo’s BBQ",
      "poi_type": "Restaurants",
      "poi_address": "5388 E Skyline Dr, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Family-owned barbecue restaurant serving signature cornbread waffles and smoked meats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-59df-76fd-b79c-7e180ed3cd61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-59df-76fd-b79c-7e180ed3cd61",
        "storage_key": "property/6767906449167811/01a117cd-59df-76fd-b79c-7e180ed3cd61.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://maddiejosbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14928599461808952601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maddie-jos-bbq",
      "poi_latitude": "33.1914535",
      "poi_longitude": "-111.5074943",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-625-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5mUP65JKocRGdU1ix0KLc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_8bfea6c8-e848-4032-86dd-f65e9c1b8c9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Tacos Mexico 1",
      "poi_type": "Restaurants",
      "poi_address": "5618 E Skyline Dr, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Authentic Mexican restaurant serving carne asada tacos and hearty burritos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-59dd-70be-97ba-2682bb01d8a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-59dd-70be-97ba-2682bb01d8a6",
        "storage_key": "property/6767906449167811/01a117cd-59dd-70be-97ba-2682bb01d8a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tacosmexico1az.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=230350354065534055&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacos-mexico-1",
      "poi_latitude": "33.191584999999996",
      "poi_longitude": "-111.5050986",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-784-3316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP8IZPmRJKocRZyz2M21eMgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_906d1ffe-bcd5-4f32-addd-95fe8b853cf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Someburros San Tan Valley",
      "poi_type": "Restaurants",
      "poi_address": "440 Combs Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Counter-service eatery serving Sonoran-style Mexican fare in an easygoing atmosphere.",
      "poi_long_description": "Counter-service eatery serving Sonoran-style Mexican fare in an easygoing atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-5a45-771a-9eed-03862202a014.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-5a45-771a-9eed-03862202a014",
        "storage_key": "property/6767906449167811/01a117cd-5a45-771a-9eed-03862202a014.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.someburros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7244809941456632071&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "someburros-san-tan-valley",
      "poi_latitude": "33.220544",
      "poi_longitude": "-111.5608767",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-361-6916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZXuSvNLKocRB7m90UG8imQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_55b34112-d9ed-43ce-808a-49efdd208165",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Geno's Giant Slice- San Tan Valley",
      "poi_type": "Restaurants",
      "poi_address": "2510 E Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Casual pizza restaurant serving New York-style slices and oven-toasted subs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6089-751c-9ada-09d1b5c167fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6089-751c-9ada-09d1b5c167fc",
        "storage_key": "property/6767906449167811/01a117cd-6089-751c-9ada-09d1b5c167fc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.genosgiantslice.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2536059971171520441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genos-giant-slice--san-tan-valley",
      "poi_latitude": "33.137395999999995",
      "poi_longitude": "-111.539251",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 480-888-1818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-1qlexIKocRuQ_EbhvlMSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_b40b9cc3-004d-4061-b93a-53c3dbf19943",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Vero Chicago Pizza",
      "poi_type": "Restaurants",
      "poi_address": "40975 N Ironwood Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Casual Chicago-style pizza restaurant serving deep-dish, thin crust, and butter crust pizzas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6154-714d-b8f9-e9979ba2628f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6154-714d-b8f9-e9979ba2628f",
        "storage_key": "property/6767906449167811/01a117cd-6154-714d-b8f9-e9979ba2628f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.verochicagopizza.com/santanvalley",
      "poi_directions_map_url": "https://maps.google.com/?cid=12026548174638349749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vero-chicago-pizza",
      "poi_latitude": "33.2510528",
      "poi_longitude": "-111.5616683",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 480-292-8686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEfkDsfhLKocRtf1wb9jh5qY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_50027d0f-822b-4923-9abb-5254914e6cbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "China Ink",
      "poi_type": "Restaurants",
      "poi_address": "40975 N Ironwood Rd b112, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Straightforward Chinese standards served in a bright, unassuming dining room.",
      "poi_long_description": "Straightforward Chinese standards served in a bright, unassuming dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-63c9-758b-b7b0-1024a755adba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-63c9-758b-b7b0-1024a755adba",
        "storage_key": "property/6767906449167811/01a117cd-63c9-758b-b7b0-1024a755adba.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://order.mealkeyway.com/merchant/49796450576279455075342b7a46337a5048664c61673d3d/main",
      "poi_directions_map_url": "https://maps.google.com/?cid=10090612772389809854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-ink",
      "poi_latitude": "33.2510452",
      "poi_longitude": "-111.561676",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 480-888-1991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdar2x2RLKocRvm5QqNoOCYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_05317d9f-d5d1-4197-924e-7a851462f431",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Angry Crab Shack",
      "poi_type": "Restaurants",
      "poi_address": "1749 Hunt Hwy 101 #101, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Casual seafood restaurant specializing in customizable Asian-Cajun seafood boils.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6406-7200-949d-f7649ebb91f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6406-7200-949d-f7649ebb91f8",
        "storage_key": "property/6767906449167811/01a117cd-6406-7200-949d-f7649ebb91f8.webp",
        "width": 818,
        "height": 376
      },
      "poi_business_url": "https://www.angrycrabshack.com/hunt-hwy-san-tan-valley-az/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15957771052985239837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "angry-crab-shack",
      "poi_latitude": "33.178421",
      "poi_longitude": "-111.5857329",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 480-608-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b14-7354-805f-6c6fa49391c8",
        "storage_key": "property/6767906449167811/01a117cb-6b14-7354-805f-6c6fa49391c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUtiNVZPKocRHUkyjDlkdd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_0ce94cfb-ebce-4dd1-88be-d26d4798d990",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "The Pork Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "3359 Combs Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Traditional butcher since 1979 also making products in-house like sausages, smoked meats & burritos.",
      "poi_long_description": "Traditional butcher since 1979 also making products in-house like sausages, smoked meats & burritos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-646c-72ae-8d53-d10b584ff5db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-646c-72ae-8d53-d10b584ff5db",
        "storage_key": "property/6767906449167811/01a117cd-646c-72ae-8d53-d10b584ff5db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.theporkshopaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9573785205346783805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pork-shop",
      "poi_latitude": "33.219713899999995",
      "poi_longitude": "-111.5297719",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-987-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-fa2846922432",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGw4pZMlLKocRPdKVkOvq3IQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "butcher_shop"
    },
    {
      "id": "custom_3b799eed-c438-4cd2-92c8-e32d3beb33b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Fry's Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "155 W Combs Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Outpost of a grocery store chain with typical offerings like produce, meat & household supplies.",
      "poi_long_description": "Outpost of a grocery store chain with typical offerings like produce, meat & household supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-345a-739f-8c42-56f3fb2ab446.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cb-345a-739f-8c42-56f3fb2ab446",
        "storage_key": "property/6767906449167811/01a117cb-345a-739f-8c42-56f3fb2ab446.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.frysfood.com/stores/grocery/az/san-tan-valley/gantzel-combs/660/00682?cid=loc_66000682_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=16396221456130048988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frys-marketplace",
      "poi_latitude": "33.2180684",
      "poi_longitude": "-111.5656632",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-474-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b03-764e-abb8-a4899f6626ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b03-764e-abb8-a4899f6626ff",
        "storage_key": "property/6767906449167811/01a117cb-6b03-764e-abb8-a4899f6626ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM8cKbotLKocR3ANFH4sUi-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_106e1fec-64ba-4726-a82f-25525ed03108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1725 Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Comprehensive department store featuring grocery sections and convenient curbside pickup.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-654f-730f-be07-78866a284a4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-654f-730f-be07-78866a284a4a",
        "storage_key": "property/6767906449167811/01a117cd-654f-730f-be07-78866a284a4a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3751-san-tan-valley-az/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16404054239693438882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.176172099999995",
      "poi_longitude": "-111.584466",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-677-2149",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-fa2846922432",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHxrdONlIKocRov8qKWvopuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ec62283f-b70c-41e6-990c-d7d0fec4869a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "40950 N Ironwood Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-665d-758e-9e28-991eeecb9db8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-665d-758e-9e28-991eeecb9db8",
        "storage_key": "property/6767906449167811/01a117cd-665d-758e-9e28-991eeecb9db8.webp",
        "width": 1082,
        "height": 1280
      },
      "poi_business_url": "https://local.safeway.com/safeway/az/san-tan-valley/40950-n-ironwood-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16021802019454091306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "33.2511588",
      "poi_longitude": "-111.5651221",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 480-758-3316",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b03-764e-abb8-a4899f6626ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b03-764e-abb8-a4899f6626ff",
        "storage_key": "property/6767906449167811/01a117cb-6b03-764e-abb8-a4899f6626ff.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrQxiNjxLKocRKoAyrwzgWN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_3def01a4-c6d4-4590-af44-945f10592da8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "333 E Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6991-704a-8d5d-ca8758b4964f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6991-704a-8d5d-ca8758b4964f",
        "storage_key": "property/6767906449167811/01a117cd-6991-704a-8d5d-ca8758b4964f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-333+e+hunt+hwy-san+tan+valley-az-85143/id=1076",
      "poi_directions_map_url": "https://maps.google.com/?cid=7169706767320920769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.1612879",
      "poi_longitude": "-111.5641609",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-987-6293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-f692a6398da5",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-Oh-TJMKocRwbLgcVHqf2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_f2c7243d-3fe8-46f8-a349-f0791094c9dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "320 E Hunt Hwy, Queen Creek, AZ 85142, USA",
      "poi_short_description": "Convenient neighborhood gas station offering fuel, snacks, and beverages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-69b7-70b3-ac35-620b90457253.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-69b7-70b3-ac35-620b90457253",
        "storage_key": "property/6767906449167811/01a117cd-69b7-70b3-ac35-620b90457253.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/queen-creek/320-hunt-hwy/2705918?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16600408898847634739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "33.1620349",
      "poi_longitude": "-111.5631085",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-987-0068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-9493-7460-a2fd-a2e9b84b7688.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-9493-7460-a2fd-a2e9b84b7688",
        "storage_key": "property/6767906449167811/01a117cd-9493-7460-a2fd-a2e9b84b7688.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ3wdiQC5JKocRM_UL1vB_YOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_e018fa5e-71df-42a6-9ef1-e0f13192c661",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "1424 Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6a47-75cf-9030-9c1b15073414.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6a47-75cf-9030-9c1b15073414",
        "storage_key": "property/6767906449167811/01a117cd-6a47-75cf-9030-9c1b15073414.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16909955362053698471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "33.181117199999996",
      "poi_longitude": "-111.5797043",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 508-390-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-fa2846922432",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPXzFanVPKocRpzPsGs86rOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9e74ca02-d79c-47c5-a8ee-9991f7cecb6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1420 Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6b15-7447-968f-a9e02af45168.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6b15-7447-968f-a9e02af45168",
        "storage_key": "property/6767906449167811/01a117cd-6b15-7447-968f-a9e02af45168.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13935816622499516855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "33.1808903",
      "poi_longitude": "-111.5793268",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-681-8134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-fa2846922432",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo-LerHBPKocRt1ERD2L3ZcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d604319d-5eed-428d-acf2-866c84d53df4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "1428 Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-69e3-724e-81bb-d575c44c6a16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-69e3-724e-81bb-d575c44c6a16",
        "storage_key": "property/6767906449167811/01a117cd-69e3-724e-81bb-d575c44c6a16.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/san-tan-valley-az-1895",
      "poi_directions_map_url": "https://maps.google.com/?cid=8667260488564517993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "33.181245",
      "poi_longitude": "-111.58046",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 602-607-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-fa2846922432",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH_RYe6xPKocRaayqRH5LSHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cosmetics_store"
    },
    {
      "id": "custom_b87f0761-c739-4e44-9bb8-785f29e28a4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "1412 Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.petsmart.com/stores/us/az/san-tan-valley-store2626.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=4040551577570511166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "33.1795683",
      "poi_longitude": "-111.579039",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-864-1084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-fa2846922432",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ7IsCABPKocRPgm8hUDsEjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_16d3c77f-284c-4fe9-8dcb-68257356c8bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Five Below",
      "poi_type": "Shopping & Retail",
      "poi_address": "1408 Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6b94-70b8-bc28-a92132208c70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6b94-70b8-bc28-a92132208c70",
        "storage_key": "property/6767906449167811/01a117cd-6b94-70b8-bc28-a92132208c70.webp",
        "width": 533,
        "height": 533
      },
      "poi_business_url": "https://locations.fivebelow.com/az/san-tan-valley/1408-w-hunt-hwy?y_source=1_MjA2Nzk3NDU0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=991852257139487121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-below",
      "poi_latitude": "33.1797907",
      "poi_longitude": "-111.5788671",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-864-1066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-fa2846922432",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJlWqcbgBJKocRkfF3cF_Eww0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_2a8b4922-963a-4648-81bc-35d62285e4f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Combs High School",
      "poi_type": "Education",
      "poi_address": "2505 E Germann Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6fca-7434-bb32-855c2fcb546c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6fca-7434-bb32-855c2fcb546c",
        "storage_key": "property/6767906449167811/01a117cd-6fca-7434-bb32-855c2fcb546c.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://jocombs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9608232345017834268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "combs-high-school",
      "poi_latitude": "33.2772965",
      "poi_longitude": "-111.5383528",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-882-3540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0Z0nWZdLKocRHNs0RGlMV4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1fdd2672-9d96-4d64-8877-55ffaac22d32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "J.O. Combs Middle School",
      "poi_type": "Education",
      "poi_address": "37611 N Pecan Creek Dr, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6d43-71a6-a635-8a93489e2daa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6d43-71a6-a635-8a93489e2daa",
        "storage_key": "property/6767906449167811/01a117cd-6d43-71a6-a635-8a93489e2daa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cms.jocombs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5911221079297089183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jo-combs-middle-school",
      "poi_latitude": "33.221147",
      "poi_longitude": "-111.548127",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-882-3510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4-W0QZVLKocRn95NrEDgCFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b07dd4f4-ed96-4f1d-823c-c40762f811d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Combs Traditional Academy",
      "poi_type": "Education",
      "poi_address": "37327 N Gantzel Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6f09-77bf-a367-652d744e2a8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6f09-77bf-a367-652d744e2a8d",
        "storage_key": "property/6767906449167811/01a117cd-6f09-77bf-a367-652d744e2a8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cta.jocombs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4911311332956617271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "combs-traditional-academy",
      "poi_latitude": "33.2184843",
      "poi_longitude": "-111.5621156",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-987-5320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp5nvx4xLKocRN7o61qJ7KEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_616e045e-c3a1-4d97-952f-2e2b392a38f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Ellsworth Elementary School",
      "poi_type": "Education",
      "poi_address": "38454 N Carolina Ave, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ellsworth.jocombs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10036467915437766251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ellsworth-elementary-school",
      "poi_latitude": "33.228344899999996",
      "poi_longitude": "-111.5552573",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-882-3520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf_NX6pBLKocRa_ZFw2SySIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_419e4349-50ec-462e-97b9-7de764c7ac82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Simonton Elementary School",
      "poi_type": "Education",
      "poi_address": "40300 N Simonton Blvd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6f75-762c-b3a7-81517bf4c698.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6f75-762c-b3a7-81517bf4c698",
        "storage_key": "property/6767906449167811/01a117cd-6f75-762c-b3a7-81517bf4c698.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://simonton.jocombs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12181046853802544985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simonton-elementary-school",
      "poi_latitude": "33.24481360000001",
      "poi_longitude": "-111.5214467",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-987-5330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfdU7T1VKKocRWU9KWZPFC6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_30a71bff-c9ce-4521-bb46-1b476cf87f0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Jack Harmon Elementary School",
      "poi_type": "Education",
      "poi_address": "39315 N Cortona Dr, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://harmon.jocombs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1174595382017790097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-harmon-elementary-school",
      "poi_latitude": "33.23768",
      "poi_longitude": "-111.5548918",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 480-882-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSRIDRpxLKocRkRD800YATRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b860a9fd-28a7-428e-a2d2-36b668b8949f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Ranch Elementary School",
      "poi_type": "Education",
      "poi_address": "43521 N Kenworthy Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7177-779f-8fd2-28cc84c89d73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-7177-779f-8fd2-28cc84c89d73",
        "storage_key": "property/6767906449167811/01a117cd-7177-779f-8fd2-28cc84c89d73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ranch.jocombs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5842382806421986807&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ranch-elementary-school",
      "poi_latitude": "33.2742766",
      "poi_longitude": "-111.5447984",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-882-3530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ22_c8jdLKocR992hSjVQFFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a1bdab62-1488-4841-9e13-fbd81817c672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Champion Schools - San Tan Valley",
      "poi_type": "Education",
      "poi_address": "1846 Bella Vis Rd, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-6f7a-723f-bb66-0a946cc9d4e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-6f7a-723f-bb66-0a946cc9d4e8",
        "storage_key": "property/6767906449167811/01a117cd-6f7a-723f-bb66-0a946cc9d4e8.webp",
        "width": 1280,
        "height": 538
      },
      "poi_business_url": "http://www.championsantan.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11816392879022219729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "champion-schools---san-tan-valley",
      "poi_latitude": "33.1625435",
      "poi_longitude": "-111.5480878",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-765-2223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnZ9B7d5JKocR0SGTsLdC_KM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8033f011-473a-450a-9101-7be91a1a1c42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "San Tan Valley Head Start",
      "poi_type": "Education",
      "poi_address": "301 Combs Rd #505, Queen Creek, AZ 85140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-74ec-7779-a95a-8450f6e63303.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-74ec-7779-a95a-8450f6e63303",
        "storage_key": "property/6767906449167811/01a117cd-74ec-7779-a95a-8450f6e63303.webp",
        "width": 1280,
        "height": 409
      },
      "poi_business_url": "http://www.pgccs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=964296843798620220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-tan-valley-head-start",
      "poi_latitude": "33.2193645",
      "poi_longitude": "-111.5611883",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-987-1845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU409qG9LKocRPKil0N7eYQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8e3e0a8b-bc84-4598-be4e-709c98ab3575",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Central Arizona College - San Tan Campus",
      "poi_type": "Education",
      "poi_address": "3736 Bella Vis Rd, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-740f-7536-8577-d0a28c0eb419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-740f-7536-8577-d0a28c0eb419",
        "storage_key": "property/6767906449167811/01a117cd-740f-7536-8577-d0a28c0eb419.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://centralaz.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6252804725458930401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-arizona-college---san-tan-campus",
      "poi_latitude": "33.1655375",
      "poi_longitude": "-111.5243484",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 520-494-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDRc4xABJKocR4Qrd3sRsxlY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_de3a95fa-4dd6-43fb-b7cb-860ef158c9c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "San Tan Mountain Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6533 W Phillips Rd, Queen Creek, AZ 85142, USA",
      "poi_short_description": "Over 10,000 acres of desert with hiking/biking trails & a visitor's center with wildlife exhibits.",
      "poi_long_description": "Over 10,000 acres of desert with hiking/biking trails & a visitor's center with wildlife exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7355-73bc-b2ac-6daf14a79d17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-7355-73bc-b2ac-6daf14a79d17",
        "storage_key": "property/6767906449167811/01a117cd-7355-73bc-b2ac-6daf14a79d17.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.maricopacountyparks.net/park-locator/san-tan-mountain-regional-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14007085308699698009&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-tan-mountain-regional-park",
      "poi_latitude": "33.167983899999996",
      "poi_longitude": "-111.6353899",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 602-506-2930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b5e-77ed-8256-233387c152df",
        "storage_key": "property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMRf1pEROKocRWWOjI-ApY8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f24e3bf7-a85a-44f3-95c7-7baa89a11450",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Schnepf Farms",
      "poi_type": "Entertainment",
      "poi_address": "24810 S Rittenhouse Rd, Queen Creek, AZ 85142, USA",
      "poi_short_description": "Family-oriented farm featuring seasonal U-pick produce and diverse holiday festivals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-71d3-7421-b54e-8c0889ec4386.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-71d3-7421-b54e-8c0889ec4386",
        "storage_key": "property/6767906449167811/01a117cd-71d3-7421-b54e-8c0889ec4386.webp",
        "width": 700,
        "height": 466
      },
      "poi_business_url": "https://schnepffarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6344015226562470146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schnepf-farms",
      "poi_latitude": "33.2239972",
      "poi_longitude": "-111.5888586",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-987-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-9489-71a3-9ccc-2f4823d23a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-9489-71a3-9ccc-2f4823d23a90",
        "storage_key": "property/6767906449167811/01a117cd-9489-71a3-9ccc-2f4823d23a90.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJfT0MYWZMKocRAuHsjDx4Clg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_8aecf221-a0b6-44b3-b36e-54bab21cb9b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Queen Creek Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "22149 E Ocotillo Rd, Queen Creek, AZ 85142, USA",
      "poi_short_description": "Community-focused performing arts theater hosting local musicals, dance recitals, and concerts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7423-726b-8f3f-6ce4dcb4db49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-7423-726b-8f3f-6ce4dcb4db49",
        "storage_key": "property/6767906449167811/01a117cd-7423-726b-8f3f-6ce4dcb4db49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.qcpac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690319770176876459&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "queen-creek-performing-arts-center",
      "poi_latitude": "33.246485",
      "poi_longitude": "-111.604976",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-987-7469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-94a0-708a-92df-77231f6702c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-94a0-708a-92df-77231f6702c2",
        "storage_key": "property/6767906449167811/01a117cd-94a0-708a-92df-77231f6702c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3ZgXu9MKocRq29iCPtcF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_3a16447d-8bba-41e7-be3d-cae3f6d4d8bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Queen Creek Olive Mill",
      "poi_type": "Entertainment",
      "poi_address": "25062 S Meridian Rd, Queen Creek, AZ 85142, USA",
      "poi_short_description": "Gourmet market & restaurant starring locally produced olive oil & specialty foods plus mill tours.",
      "poi_long_description": "Gourmet market & restaurant starring locally produced olive oil & specialty foods plus mill tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-779c-7743-b7c2-7076f87b5831.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-779c-7743-b7c2-7076f87b5831",
        "storage_key": "property/6767906449167811/01a117cd-779c-7743-b7c2-7076f87b5831.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.queencreekolivemill.com/pages/queen-creek-estate",
      "poi_directions_map_url": "https://maps.google.com/?cid=6528968591154679601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "queen-creek-olive-mill",
      "poi_latitude": "33.2211041",
      "poi_longitude": "-111.5833015",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 480-888-9290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-9489-71a3-9ccc-2f4823d23a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-9489-71a3-9ccc-2f4823d23a90",
        "storage_key": "property/6767906449167811/01a117cd-9489-71a3-9ccc-2f4823d23a90.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJUzdRL25MKocRMQ91eVeOm1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_82e4da0f-786d-46ab-a513-d478bdff630b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Pecan Lake Entertainment",
      "poi_type": "Entertainment",
      "poi_address": "25004 S 206th St, Queen Creek, AZ 85142, USA",
      "poi_short_description": "Family-oriented amusement park featuring a ropes course, go-karts, and axe throwing alongside various dining options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-3909-70fa-ab7e-9d98b72d53a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cb-3909-70fa-ab7e-9d98b72d53a7",
        "storage_key": "property/6767906449167811/01a117cb-3909-70fa-ab7e-9d98b72d53a7.webp",
        "width": 1280,
        "height": 1023
      },
      "poi_business_url": "https://www.gopecanlake.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11894426697882177326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pecan-lake-entertainment",
      "poi_latitude": "33.220054499999996",
      "poi_longitude": "-111.6403958",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-943-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b12-7712-99c5-9561d8e15ea7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b12-7712-99c5-9561d8e15ea7",
        "storage_key": "property/6767906449167811/01a117cb-6b12-7712-99c5-9561d8e15ea7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ_V_EixNKocRLo8w9g9-EaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_da8c12fd-6e27-4b55-a4dc-0891903354fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "FatCats Queen Creek",
      "poi_type": "Entertainment",
      "poi_address": "20660 E Riggs Rd, Queen Creek, AZ 85142, USA",
      "poi_short_description": "Family entertainment center featuring luxury reclining movie theaters, bowling lanes, and a modern arcade.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7a4a-736f-ae30-9cd472681028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-7a4a-736f-ae30-9cd472681028",
        "storage_key": "property/6767906449167811/01a117cd-7a4a-736f-ae30-9cd472681028.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.fatcatsfun.com/queencreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=9159572045241562168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fatcats-queen-creek",
      "poi_latitude": "33.2207126",
      "poi_longitude": "-111.6368265",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-841-6044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948a-72db-81b4-cb15d360218a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948a-72db-81b4-cb15d360218a",
        "storage_key": "property/6767906449167811/01a117cd-948a-72db-81b4-cb15d360218a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJM1iGvBlNKocROLQ44z5WHX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9ed94531-ba5b-4b7b-b69b-3c0d0a3fb778",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Queen Creek Historic Town Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22350 S Ellsworth Rd, Queen Creek, AZ 85142, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7b30-767c-8241-3f868cff9aae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-7b30-767c-8241-3f868cff9aae",
        "storage_key": "property/6767906449167811/01a117cd-7b30-767c-8241-3f868cff9aae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.queencreekaz.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10907554810453993901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "queen-creek-historic-town-hall",
      "poi_latitude": "33.244749",
      "poi_longitude": "-111.6348992",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-358-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-94a5-70e8-b7b2-c520a6d6706f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-94a5-70e8-b7b2-c520a6d6706f",
        "storage_key": "property/6767906449167811/01a117cd-94a5-70e8-b7b2-c520a6d6706f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDzh7ltJNKocRrak2NU9rX5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_84a672d7-0337-4865-b3d8-05520da0d6b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Harkins Theatres SanTan Village",
      "poi_type": "Entertainment",
      "poi_address": "2298 E Williams Field Rd, Gilbert, AZ 85296, USA",
      "poi_short_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_long_description": "Modern multiplex chain showing blockbusters & a few independent films; some venues offer childcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-77b2-76da-abeb-15df8529c0e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-77b2-76da-abeb-15df8529c0e9",
        "storage_key": "property/6767906449167811/01a117cd-77b2-76da-abeb-15df8529c0e9.webp",
        "width": 1280,
        "height": 1006
      },
      "poi_business_url": "https://harkins.com/theatres/santan-village?utm_source=google_listing&utm_medium=web&utm_campaign=gmb&utm_id=local_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5048356203829720723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harkins-theatres-santan-village",
      "poi_latitude": "33.3111185",
      "poi_longitude": "-111.7405835",
      "poi_miles_from_property": "13.5",
      "poi_walking_minutes": "4 hours 55 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 480-821-3356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948a-72db-81b4-cb15d360218a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948a-72db-81b4-cb15d360218a",
        "storage_key": "property/6767906449167811/01a117cd-948a-72db-81b4-cb15d360218a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJD-xV_GqsK4cRk_boVDhdD0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a06a5b13-ee09-479f-ab97-fb5ba7ff7cb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "SanTan Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "2218 E Williams Field Rd Suite 235, Gilbert, AZ 85295, USA",
      "poi_short_description": "Vibrant outdoor shopping mall featuring a variety of retail stores and diverse dining options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-787d-7489-a248-996b7379dd0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-787d-7489-a248-996b7379dd0a",
        "storage_key": "property/6767906449167811/01a117cd-787d-7489-a248-996b7379dd0a.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.shopsantanvillage.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=328567385978681920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santan-village",
      "poi_latitude": "33.311120599999995",
      "poi_longitude": "-111.7429808",
      "poi_miles_from_property": "13.4",
      "poi_walking_minutes": "4 hours 54 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 480-282-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-fa2846922432",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-fa2846922432.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-S0mfkKsK4cRQLoJ9ktOjwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0c37b681-4b9a-427b-a821-4ebe12ce580e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Banner Ironwood Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "37000 N Gantzel Rd, Queen Creek, AZ 85140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-444b-774a-8168-bd15739b0f7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cb-444b-774a-8168-bd15739b0f7b",
        "storage_key": "property/6767906449167811/01a117cb-444b-774a-8168-bd15739b0f7b.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/queen-creek/banner-ironwood-medical-center?y_source=1_MTE5MDczNTAtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=17672546354847761979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "banner-ironwood-medical-center",
      "poi_latitude": "33.2144262",
      "poi_longitude": "-111.5656344",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 480-394-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b12-7712-99c5-9a3dde0b435a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b12-7712-99c5-9a3dde0b435a",
        "storage_key": "property/6767906449167811/01a117cb-6b12-7712-99c5-9a3dde0b435a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2Ubm_RLKocRO0ZTzUZ_QfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_2e4389ef-8fb2-4aaa-b592-385757cc35df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Emergency Room at Arizona General Hospital - San Tan Valley, AZ",
      "poi_type": "Health and Wellness",
      "poi_address": "1419 Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7b2c-73cf-bdc9-82f2254414a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-7b2c-73cf-bdc9-82f2254414a6",
        "storage_key": "property/6767906449167811/01a117cd-7b2c-73cf-bdc9-82f2254414a6.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://www.commonspirit.org/find-a-location/emergency-room-at-arizona-general-hospital-san-tan-valley-4059",
      "poi_directions_map_url": "https://maps.google.com/?cid=14011671425282263781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emergency-room-at-arizona-general-hospital---san-tan-valley-az",
      "poi_latitude": "33.1767281",
      "poi_longitude": "-111.5820904",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-245-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-f692a6398da5",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr1Y6Tl1PKocR5cpwnex0c8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_9e4b8ae1-d9ea-4693-a3b0-710addf348c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Banner Urgent Care | San Tan Valley, AZ | Ironwood Rd",
      "poi_type": "Health and Wellness",
      "poi_address": "40773 N Ironwood Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7caf-74bb-9a0c-9244ffe0ff95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-7caf-74bb-9a0c-9244ffe0ff95",
        "storage_key": "property/6767906449167811/01a117cd-7caf-74bb-9a0c-9244ffe0ff95.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/san-tan-valley/banner-urgent-care-ironwood?cid=yext%3Asearch_listing%3Alocations%3Abucs&y_source=1_MTE5MDc2NTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3992731519059633962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "banner-urgent-care--san-tan-valley-az--ironwood-rd",
      "poi_latitude": "33.249513",
      "poi_longitude": "-111.5626303",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 480-827-5760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-f692a6398da5",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRI2zWRLKocRKicOhSkIaTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_51ba2b17-6cbb-4287-99fa-dbae574cb21e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1725 Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7b8d-766d-9ac9-1a69a652d9a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-7b8d-766d-9ac9-1a69a652d9a6",
        "storage_key": "property/6767906449167811/01a117cd-7b8d-766d-9ac9-1a69a652d9a6.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/3751-san-tan-valley-az/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10567114541094044070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "33.176172099999995",
      "poi_longitude": "-111.584466",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-677-2540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b1b-76ae-a773-41c1e37e5da8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b1b-76ae-a773-41c1e37e5da8",
        "storage_key": "property/6767906449167811/01a117cb-6b1b-76ae-a773-41c1e37e5da8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHxrdONlIKocRpoHGKrDupZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6f3449e7-06cf-49ea-88a5-d6fe270b1cea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Fry's Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "542 E Hunt Hwy, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7de5-778c-85af-c99ba32fab27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-7de5-778c-85af-c99ba32fab27",
        "storage_key": "property/6767906449167811/01a117cd-7de5-778c-85af-c99ba32fab27.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.frysfood.com/rx/pharmacy/details/660/00084?cid=loc_66000084P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13817281134062876738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frys-pharmacy",
      "poi_latitude": "33.1607335",
      "poi_longitude": "-111.5601714",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-888-1781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b1b-76ae-a773-41c1e37e5da8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b1b-76ae-a773-41c1e37e5da8",
        "storage_key": "property/6767906449167811/01a117cb-6b1b-76ae-a773-41c1e37e5da8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0jJEy9JKocRQjiG_fvXwL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_51b4d0e0-c579-4974-b821-bd86517850a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Mountainside Fitness San Tan",
      "poi_type": "Health and Wellness",
      "poi_address": "218 W Combs Rd, Queen Creek, AZ 85140, USA",
      "poi_short_description": "Spacious, modern fitness center offering state-of-the-art equipment and diverse group fitness classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-7ec2-767f-a8e9-a97e0e83245b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-7ec2-767f-a8e9-a97e0e83245b",
        "storage_key": "property/6767906449167811/01a117cd-7ec2-767f-a8e9-a97e0e83245b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://mountainsidefitness.com/san-tan-grand-opening/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16512680354583102616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountainside-fitness-san-tan",
      "poi_latitude": "33.2212296",
      "poi_longitude": "-111.5667077",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-219-5018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-f692a6398da5",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtccIIzBLKocRmER_aEvTKOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d95c46e0-cb8a-4860-80de-9755722c5d63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "CrossFit Solid Gold",
      "poi_type": "Health and Wellness",
      "poi_address": "2769 Combs Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Welcoming CrossFit gym featuring supportive, expert coaching and scalable workouts for all skill levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-8156-75aa-b81a-c603f464f69c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-8156-75aa-b81a-c603f464f69c",
        "storage_key": "property/6767906449167811/01a117cd-8156-75aa-b81a-c603f464f69c.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://www.cfsolidgold.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9503636600664220901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-solid-gold",
      "poi_latitude": "33.2193645",
      "poi_longitude": "-111.5358394",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-660-2922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-f692a6398da5",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZX7GECxNKocR5eT9yCKz44M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_777f0999-e770-40cb-bc49-0d60944f8de8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "40601 N Gantzel Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "24-hour gym featuring a variety of cardio and strength training equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-8306-7518-b5ec-b13c6b782785.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-8306-7518-b5ec-b13c6b782785",
        "storage_key": "property/6767906449167811/01a117cd-8306-7518-b5ec-b13c6b782785.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/san-tan-valley-arizona-1654/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=1654",
      "poi_directions_map_url": "https://maps.google.com/?cid=5484006761688876253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "33.247856399999996",
      "poi_longitude": "-111.5614559",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 480-690-6444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-f692a6398da5",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUTF_XpLKocR3UROIBgbG0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_64ada50b-77a0-42e9-8d2a-9b6ba9cec5d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Soul Sisters Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "116 W Brahman Blvd, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-8047-75cf-9488-e116fa57ad0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-8047-75cf-9488-e116fa57ad0a",
        "storage_key": "property/6767906449167811/01a117cd-8047-75cf-9488-e116fa57ad0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://soul-sisters-yoga-and-metaphysical.square.site/?fbclid=IwAR3wW_njAVvGSqECSx0xitYyDOia00GlsnWvKjCwLWRqBqWyCEPv5GRPAo8",
      "poi_directions_map_url": "https://maps.google.com/?cid=6775166089824456659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soul-sisters-yoga",
      "poi_latitude": "33.195864",
      "poi_longitude": "-111.5666495",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 505-504-5747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-f692a6398da5",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-zae89LKocR009Cjqk5Bl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_718703f7-ccb9-466d-917e-eb39ecd0bf25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Skyline Ranch Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "33067 N Pebble Creek Dr, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-80a9-702f-af38-2a6da5742ad5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-80a9-702f-af38-2a6da5742ad5",
        "storage_key": "property/6767906449167811/01a117cd-80a9-702f-af38-2a6da5742ad5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17589313647354810188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyline-ranch-community-park",
      "poi_latitude": "33.1802862",
      "poi_longitude": "-111.5744743",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b5e-77ed-8256-233387c152df",
        "storage_key": "property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY62wsrNOKocRTI-D8ZHLGfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d282287e-2726-4091-a7b8-0a226c23d35e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Pebble Creek Picnic Pavilion",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "775 W Saguaro Ln, Queen Creek, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17881430322981693913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pebble-creek-picnic-pavilion",
      "poi_latitude": "33.1830011",
      "poi_longitude": "-111.5765003",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b5e-77ed-8256-233387c152df",
        "storage_key": "property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTVopIJPKocR2ek4jSOaJ_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c4505056-e339-4180-89cb-3ef68154e474",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Circle Cross Ranch",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "W Empire Blvd, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18440041919769806615&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-cross-ranch",
      "poi_latitude": "33.198453799999996",
      "poi_longitude": "-111.5712469",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-f692a6398da5",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJidckYABNKocRFwcxL20w6P8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_8fadc4b1-6961-41ba-a96f-894b7c08ba1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Desert Rose Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-815b-74e1-a62e-3b45c07a6e28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-815b-74e1-a62e-3b45c07a6e28",
        "storage_key": "property/6767906449167811/01a117cd-815b-74e1-a62e-3b45c07a6e28.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13170372306096487135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "desert-rose-park",
      "poi_latitude": "33.1586673",
      "poi_longitude": "-111.5547077",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b5e-77ed-8256-233387c152df",
        "storage_key": "property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6CakyZJKocR3_qFMNWPxrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_d7be83ce-f3c2-429d-861a-b904c82d6548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Granada Park (Bella Vista Farms Community Playground)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-85a3-758a-a0b3-91aca6733064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-85a3-758a-a0b3-91aca6733064",
        "storage_key": "property/6767906449167811/01a117cd-85a3-758a-a0b3-91aca6733064.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7483557314672912555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "granada-park-bella-vista-farms-community-playground",
      "poi_latitude": "33.1729286",
      "poi_longitude": "-111.528514",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-f692a6398da5",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE6FdZABJKocRq-haZbrv2mc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_52880633-b3df-44bb-9ebe-a394f4a112fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Mansel Carter Oasis Park Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19535 E Appleby Rd, Queen Creek, AZ 85142, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-81d5-708d-8558-fef7c79389a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-81d5-708d-8558-fef7c79389a4",
        "storage_key": "property/6767906449167811/01a117cd-81d5-708d-8558-fef7c79389a4.webp",
        "width": 800,
        "height": 560
      },
      "poi_business_url": "https://www.queencreek.org/departments/parks-recreation/parks-and-recreation-master-plan-update/mansel-carter-oasis-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3033422383810923345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mansel-carter-oasis-park-lake",
      "poi_latitude": "33.2552149",
      "poi_longitude": "-111.6592827",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 480-358-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b5e-77ed-8256-233387c152df",
        "storage_key": "property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ3qdcYxNKocRUcvEGJbhGCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f45c2a7a-c740-48d4-b4ee-cd9fcb7d8455",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Paisley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1641 W Paisley Dr, Queen Creek, AZ 85142, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-880b-70cc-9e77-c54888b884e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-880b-70cc-9e77-c54888b884e3",
        "storage_key": "property/6767906449167811/01a117cd-880b-70cc-9e77-c54888b884e3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12450567685685016350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paisley-park",
      "poi_latitude": "33.200482199999996",
      "poi_longitude": "-111.5832367",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b5e-77ed-8256-233387c152df",
        "storage_key": "property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgb87QldNKocRHnc2HVhNyaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_33e6317a-f1c4-43c3-8e7e-0b4df6bf314c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Greens Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1554 E Omega Dr, San Tan Valley, AZ 85143, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-86d9-73fc-8327-fd3d708dc673.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-86d9-73fc-8327-fd3d708dc673",
        "storage_key": "property/6767906449167811/01a117cd-86d9-73fc-8327-fd3d708dc673.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=494133673198290759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greens-park",
      "poi_latitude": "33.15524010000001",
      "poi_longitude": "-111.550396",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b5e-77ed-8256-233387c152df",
        "storage_key": "property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVV3PnSBJKocRRweLLvWD2wY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_177880e5-339a-458d-ae70-64d6844f3bd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Intel Ocotillo Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4500 S Dobson Rd, Chandler, AZ 85248, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-87f8-732b-9c03-905aba2ebf8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-87f8-732b-9c03-905aba2ebf8b",
        "storage_key": "property/6767906449167811/01a117cd-87f8-732b-9c03-905aba2ebf8b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9593540309325587613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intel-ocotillo-campus",
      "poi_latitude": "33.2419031",
      "poi_longitude": "-111.88155770000002",
      "poi_miles_from_property": "20.5",
      "poi_walking_minutes": "7 hours 28 mins",
      "poi_biking_minutes": "1 hour 41 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 408-765-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6aff-7027-94d5-f692a6398da5",
        "storage_key": "property/6767906449167811/01a117cb-6aff-7027-94d5-f692a6398da5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx5-tzD8AK4cRnSS-IxUaI4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ee6e9810-8dbe-4be0-8f84-e88d70010761",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Arizona State University Polytechnic Campus",
      "poi_type": "Education",
      "poi_address": "7001 E Williams Field Rd, Mesa, AZ 85212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-8608-77cc-babd-7bb4992bd08f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-8608-77cc-babd-7bb4992bd08f",
        "storage_key": "property/6767906449167811/01a117cd-8608-77cc-babd-7bb4992bd08f.webp",
        "width": 1080,
        "height": 758
      },
      "poi_business_url": "http://campus.asu.edu/polytechnic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3286714134695415506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arizona-state-university-polytechnic-campus",
      "poi_latitude": "33.3060092",
      "poi_longitude": "-111.6785238",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 480-727-1585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-c0dQ52tK4cR0o7GfBfBnC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_30567f55-58ce-47d7-9e0c-ed7c0d0ba2e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Mesa Gateway Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6033 S Sossaman Rd, Mesa, AZ 85212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-8b89-74dd-8fa1-1de199cd9364.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-8b89-74dd-8fa1-1de199cd9364",
        "storage_key": "property/6767906449167811/01a117cd-8b89-74dd-8fa1-1de199cd9364.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.gatewayairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11873809920753535279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mesa-gateway-airport",
      "poi_latitude": "33.3089787",
      "poi_longitude": "-111.6559353",
      "poi_miles_from_property": "10.1",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 480-988-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6dd6-7199-8b8a-f4808e6de2fb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6dd6-7199-8b8a-f4808e6de2fb",
        "storage_key": "property/6767906449167811/01a117cb-6dd6-7199-8b8a-f4808e6de2fb.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1BeVICtK4cRLwkGeTY_yKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2a8d20c4-953d-4b90-ab27-699ffc7ea3de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Embry-Riddle Aeronautical University - Phoenix-Mesa",
      "poi_type": "Education",
      "poi_address": "5930 S Sossaman Rd #102, Mesa, AZ 85212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-8a0f-769b-a713-b1e40c2c9c9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-8a0f-769b-a713-b1e40c2c9c9a",
        "storage_key": "property/6767906449167811/01a117cd-8a0f-769b-a713-b1e40c2c9c9a.webp",
        "width": 1280,
        "height": 426
      },
      "poi_business_url": "https://erau.edu/about/locations?utm_source=GMB&utm_medium=organic&utm_campaign=phoenixmesa#phoenixmesaaz",
      "poi_directions_map_url": "https://maps.google.com/?cid=4493410417699402612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "embry-riddle-aeronautical-university---phoenix-mesa",
      "poi_latitude": "33.3086201",
      "poi_longitude": "-111.6703823",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 480-279-1150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJczy3Eb8AK4cRdDMDwffMWz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6b14ac82-f0cb-404a-b670-83877ccf2a88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Chandler-Gilbert Community College - Williams Campus",
      "poi_type": "Education",
      "poi_address": "7360 E Tahoe Ave, Mesa, AZ 85212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-8b9d-71dd-aeb6-4f6543ecdaf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-8b9d-71dd-aeb6-4f6543ecdaf8",
        "storage_key": "property/6767906449167811/01a117cd-8b9d-71dd-aeb6-4f6543ecdaf8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cgc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18039201967742540552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chandler-gilbert-community-college---williams-campus",
      "poi_latitude": "33.31101280000001",
      "poi_longitude": "-111.6738817",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 480-732-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv8FHa4StK4cRCFvSJp0eWPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1074a114-90e4-4a98-9e7b-54e09ae05b46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Dignity Health Chandler Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1955 W Frye Rd, Chandler, AZ 85224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-8ba1-7696-a5ce-466f04a0bc53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-8ba1-7696-a5ce-466f04a0bc53",
        "storage_key": "property/6767906449167811/01a117cd-8ba1-7696-a5ce-466f04a0bc53.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.commonspirit.org/find-a-location/dignity-health-chandler-regional-medical-center-2896",
      "poi_directions_map_url": "https://maps.google.com/?cid=15054899188228917112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dignity-health-chandler-regional-medical-center",
      "poi_latitude": "33.297157999999996",
      "poi_longitude": "-111.8746302",
      "poi_miles_from_property": "20.8",
      "poi_walking_minutes": "7 hours 36 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 480-728-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b12-7712-99c5-9a3dde0b435a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b12-7712-99c5-9a3dde0b435a",
        "storage_key": "property/6767906449167811/01a117cb-6b12-7712-99c5-9a3dde0b435a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJNT5qLboAK4cReIezIwy_7dA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5822d14a-ff06-48ba-ba91-57356102c272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Pinal County Assessor’s Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "31 N Pinal St # E, Florence, AZ 85132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-8e42-75db-b036-b326070448d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-8e42-75db-b036-b326070448d1",
        "storage_key": "property/6767906449167811/01a117cd-8e42-75db-b036-b326070448d1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pinalcountyaz.gov/Assessor/Pages/Assessor.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10812691773127825597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinal-county-assessors-office",
      "poi_latitude": "33.0322143",
      "poi_longitude": "-111.3844308",
      "poi_miles_from_property": "23.8",
      "poi_walking_minutes": "8 hours 37 mins",
      "poi_biking_minutes": "1 hour 57 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 520-866-6361",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-94a5-70e8-b7b2-c520a6d6706f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-94a5-70e8-b7b2-c520a6d6706f",
        "storage_key": "property/6767906449167811/01a117cd-94a5-70e8-b7b2-c520a6d6706f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjyuGLJ8-KocRvZgSK-FlDpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_42104fca-236b-4c7f-886a-0a0360e0373e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "UND Aerospace Foundation Flight Training Center",
      "poi_type": "Education",
      "poi_address": "5865 S Sossaman Rd, Mesa, AZ 85212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-8d7b-71cc-8338-a480b45af0b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cd-8d7b-71cc-8338-a480b45af0b2",
        "storage_key": "property/6767906449167811/01a117cd-8d7b-71cc-8338-a480b45af0b2.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://airlinepilot.training/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1275897885187951986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "und-aerospace-foundation-flight-training-center",
      "poi_latitude": "33.309422999999995",
      "poi_longitude": "-111.6692635",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 480-809-4499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cd-948b-74f3-bc4d-5360f85d4507",
        "storage_key": "property/6767906449167811/01a117cd-948b-74f3-bc4d-5360f85d4507.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcWdBLYStK4cRcs1M2F3mtBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_a572da34-cb94-4f0c-b825-6fe212b214a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Frontier Family Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "20039 S 220th St, Queen Creek, AZ 85142, USA",
      "poi_short_description": "Expansive family-friendly park featuring a shaded playground and extensive sports facilities including pickleball and basketball courts.",
      "poi_long_description": "Visitors say this park offers a wide variety of well-maintained sports courts, including pickleball, basketball, and baseball, along with a large, diverse playground and splash pad for children. They also highlight the clean, well-kept restrooms and ample shaded seating areas. Guests mention the park is family-friendly, with plenty of space for activities and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-58b0-76ef-b128-34c1896f2e7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a117cb-58b0-76ef-b128-34c1896f2e7b",
        "storage_key": "property/6767906449167811/01a117cb-58b0-76ef-b128-34c1896f2e7b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.queencreekaz.gov/residents/parks-recreation/new-park-projects",
      "poi_directions_map_url": "https://maps.google.com/?cid=1165582122508550512&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frontier-family-park",
      "poi_latitude": "33.2661971",
      "poi_longitude": "-111.6065408",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a117cb-6b5e-77ed-8256-233387c152df",
        "storage_key": "property/6767906449167811/01a117cb-6b5e-77ed-8256-233387c152df.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-ttZnNNKocRcAGr0MP6LBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d71221bb-7b5a-4b63-8303-a1b604c1323a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "38158 N Gantzel Rd, San Tan Valley, AZ 85140, USA",
      "poi_short_description": "Drive-thru coffee stand on Gantzel Rd serving coffee, energy drinks, smoothies and teas, open early every day.",
      "poi_long_description": "Drive-thru coffee stand on Gantzel Rd serving coffee, energy drinks, smoothies and teas, open early every day.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJBRwSP-ZLKocRHXcyUab9IT4",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "33.2256446",
      "poi_longitude": "-111.5636458",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJBRwSP-ZLKocRHXcyUab9IT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_1e1d7516-db1c-4cba-8270-3d811b43d849",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "Better Buzz",
      "poi_type": "Restaurants",
      "poi_address": "37716 N Gantzel Rd, Queen Creek, AZ 85140, USA",
      "poi_short_description": "Coffee shop with drive-thru on Gantzel Rd serving espresso drinks, breakfast and açaí bowls, opening at 4:30 AM.",
      "poi_long_description": "Coffee shop with drive-thru on Gantzel Rd serving espresso drinks, breakfast and açaí bowls, opening at 4:30 AM.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJE9TtE-FLKocRXtsOTn0V6k8",
      "poi_item_slug": "better-buzz",
      "poi_latitude": "33.2217685",
      "poi_longitude": "-111.5640318",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-790-9335",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJE9TtE-FLKocRXtsOTn0V6k8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_038fd9a3-30e0-41b1-a87f-3c690c539f36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "American Leadership Academy, Ironwood Pre-K-6",
      "poi_type": "Education",
      "poi_address": "650 W Combs Rd, Queen Creek, AZ 85140, USA",
      "poi_short_description": "Public charter school campus serving preschool through 6th grade on W Combs Rd.",
      "poi_long_description": "Public charter school campus serving preschool through 6th grade on W Combs Rd.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJ1yx_sYtLKocRE5MaMbw3n6E",
      "poi_item_slug": "american-leadership-academy-ironwood-pre-k-6",
      "poi_latitude": "33.221168",
      "poi_longitude": "-111.5710373",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-344-9899",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ1yx_sYtLKocRE5MaMbw3n6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d1c95e31-de1c-45b3-9d34-83414d5e9c08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "custom",
      "poi_name": "American Leadership Academy, Ironwood 7-12",
      "poi_type": "Education",
      "poi_address": "850 W Combs Rd, Queen Creek, AZ 85140, USA",
      "poi_short_description": "Public charter school campus serving grades 7 through 12 on W Combs Rd.",
      "poi_long_description": "Public charter school campus serving grades 7 through 12 on W Combs Rd.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://www.google.com/maps/place/?q=place_id:ChIJbWaus4tLKocRnb9lgLQyip8",
      "poi_item_slug": "american-leadership-academy-ironwood-7-12",
      "poi_latitude": "33.221181",
      "poi_longitude": "-111.572467",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 480-344-9898",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJbWaus4tLKocRnb9lgLQyip8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    }
  ],
  "office_hours": [
    {
      "id": "ec_1ab9b45beeb3d87f246de5e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6a6f36e0f1b2c692db18d92a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_340dc89b97d89e9f36b0f4d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "19:00"
    },
    {
      "id": "ec_3b63e4bfe8c995769467c3bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5a2adbd7ef93cda1359d427e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_7995afdda091867548b42105",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_a954cefd63554290bdd6e028",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_24664bc3a65c54ca4ff9cd0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "2893444",
      "pet_type": "all",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_8aeae9e6cff6fb330ae8552d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "2893442",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_54689608750361ca9136d330",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "yardi",
      "external_id": "2893443",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 0,
      "monthly_rent": 0,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a1372f-0b7f-7266-b1dd-450100551dba",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "FLATZ 480 Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811"
    },
    {
      "lead_collector_id": "01a1372f-0c11-7231-8d69-838fa4fde451",
      "lead_source": "LANDING_PAGE",
      "name": "FLATZ 480 Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "luxury-apartment-washer-dryer-san-tan-valley",
      "search_query": "luxury apartment with in-home washer dryer san tan valley",
      "category": "Amenity",
      "h1_title": "Luxury Apartment with In-Home Washer & Dryer",
      "h2_subtitle": "Experience luxury living in San Tan Valley with FLATZ 480. Enjoy the convenience of an in-home washer and dryer in our upscale apartments.",
      "page_copy": "Welcome to FLATZ 480, where luxury meets convenience in the heart of San Tan Valley. Our exquisite apartments come fully equipped with an in-home washer and dryer, designed to free up your time for the more important things in life. Say goodbye to laundry trips and hello to seamless living in a vibrant community.\n\nIn addition to these impressive features, FLATZ 480 offers a variety of amenities that cater to your lifestyle. From reserved and covered parking to keep your vehicle protected, to a coffee bar perfect for morning routines, our community ensures every need is met. Dive into leisure with our pickleball courts or let kids enjoy the outdoor play area. Come and discover what makes our luxury apartment with an in-home washer and dryer in San Tan Valley truly special.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apt with In-Home Washer & Dryer",
      "seo_description": "Discover luxury living at FLATZ 480, featuring in-home washers and dryers in San Tan Valley. Enjoy convenient and upscale apartment living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-dog-park-pinal-county",
      "search_query": "dog friendly apartments with dog park pinal county",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments with Dog Park",
      "h2_subtitle": "Welcome to FLATZ 480 in Pinal County, where dogs are part of the family. Our pet-friendly community includes a dedicated dog park.",
      "page_copy": "At FLATZ 480, nestled in the heart of Pinal County, we know that pets are family. That's why our dog friendly apartments go above and beyond to ensure you and your furry friend feel right at home. With a spacious dog park on-site, your dog will enjoy the freedom to roam and play in a safe, dedicated area.\n\nOur community is designed with both you and your pet in mind, providing a vibrant living environment. Aside from our exceptional facilities like the in-home washer and dryer and coffee bar, we offer amenities that cater to all family members, two-legged and four. Come see why FLATZ 480 is the ideal choice for dog lovers looking for the perfect apartments with convenient access to a dog park in Pinal County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments with Dog Park",
      "seo_description": "Live at FLATZ 480, Pinal County’s pet-friendly community with a dog park. Perfect for you and your furry friend’s lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-san-tan-valley-az",
      "search_query": "resort style pool apartments in san tan valley az",
      "category": "Amenity",
      "h1_title": "Resort Style Pool Apartments in San Tan Valley",
      "h2_subtitle": "Discover the luxury of FLATZ 480 in San Tan Valley, AZ. Enjoy apartments featuring resort-style amenities including a pool.",
      "page_copy": "Welcome to FLATZ 480, the epitome of resort-style living in San Tan Valley, AZ. Our community offers luxurious apartments featuring the finest amenities, designed with your comfort in mind. Imagine unwinding by our resort-style pool, the perfect oasis for relaxation and enjoyment under the Arizona sun.\n\nBeyond our breathtaking pool, FLATZ 480 provides residents with a host of lifestyle-enhancing features. Experience the convenience of in-home washers and dryers, and maximize relaxation time with reserved and covered parking. Socialize at our coffee bar or partake in a game of pickleball. Join us at FLATZ 480 and experience resort-style pool living in the thriving locale of San Tan Valley, AZ.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Style Pool Apartments – San Tan Valley",
      "seo_description": "Explore FLATZ 480 in San Tan Valley, AZ. Enjoy luxurious apartments complemented by a resort-style pool and exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "apartments-reserved-parking-ev-charging-85140",
      "search_query": "apartments with reserved parking and ev charging 85140",
      "category": "Amenity",
      "h1_title": "Apartments with Reserved Parking & EV Charging",
      "h2_subtitle": "Explore FLATZ 480 in San Tan Valley, 85140, where convenience meets modern living with reserved parking and EV charging stations.",
      "page_copy": "FLATZ 480 proudly offers modern conveniences that cater to contemporary lifestyles, including reserved parking and EV charging stations, right in San Tan Valley's 85140 area. Our apartments are designed to add ease and efficiency to your daily routines while allowing you to be eco-conscious with electric vehicle support readily available.\n\nApart from these standout features, our community boasts several other amenities meant for comfort and leisure. Enjoy the convenience of an in-home washer and dryer, partake in friendly competition on our pickleball courts, or relax at our coffee bar. Discover the perfect blend of practicality and luxury at FLATZ 480, where we pave the way for a futuristic lifestyle in Arizona's thriving community of San Tan Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apt with Reserved Parking & EV Charging 85140",
      "seo_description": "Choose FLATZ 480 in San Tan Valley 85140 for reserved parking and EV charging. Modern living meets convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "modern-apartments-fitness-center-san-tan-valley",
      "search_query": "modern apartments with fitness center san tan valley",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Fitness Center",
      "h2_subtitle": "FLATZ 480 offers modern living in San Tan Valley. Enjoy our well-equipped fitness center and other premier amenities.",
      "page_copy": "Discover the perfect blend of style and functionality at FLATZ 480, where our modern apartments come equipped with a state-of-the-art fitness center right here in San Tan Valley. Whether you're starting your day with a workout or winding down in the evening, our fitness center offers everything you need to maintain a healthy lifestyle.\n\nFLATZ 480 is more than just a place to live; it’s a community designed around your comfort and convenience. Our residents enjoy a range of amenities, including an in-home washer and dryer, reserved and covered parking, and social spaces like a coffee bar. Come and experience the vibrant life at FLATZ 480, where modern living meets community spirit in San Tan Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apts with Fitness Center – San Tan Valley",
      "seo_description": "Experience modern living at FLATZ 480 San Tan Valley. Enjoy our apartments with a fitness center and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "studio-apartments-san-tan-valley",
      "search_query": "studio apartments san tan valley",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in San Tan Valley",
      "h2_subtitle": "Experience sleek living in San Tan Valley with our stylish studio apartments at FLATZ 480, designed for your comfort.",
      "page_copy": "FLATZ 480 offers chic and modern studio apartments in the heart of San Tan Valley, perfect for those who value an elegant living space with maximum efficiency. Our studio apartments are thoughtfully designed to provide comfort, functionality, and style—all key elements for a delightful living experience.\n\nBeyond our stunning studios, you’ll find a community rich in amenities at FLATZ 480. Enjoy the convenience of in-home washers and dryers, relax with ease knowing you have reserved and covered parking, or mingle at our community coffee bar. With these features and more, FLATZ 480 delivers the perfect studio apartment experience in San Tan Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stylish Studio Apartments – San Tan Valley",
      "seo_description": "Discover FLATZ 480's studio apartments in San Tan Valley. Modern living with convenient amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "1-bedroom-apartment-85140",
      "search_query": "1 bedroom apartment 85140",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartment in 85140",
      "h2_subtitle": "Explore comfortable living with our 1 bedroom apartments at FLATZ 480, offering modern amenities in the 85140 area of San Tan Valley.",
      "page_copy": "Find your perfect home in the 1 bedroom apartments at FLATZ 480, centrally located in San Tan Valley's bustling 85140 area. Our thoughtfully designed apartments offer a harmonious blend of style and comfort, ideal for singles or couples seeking a cozy living space with contemporary touches.\n\nResidents of FLATZ 480 enjoy an array of amenities aimed at enhancing their living experience. You’ll appreciate the convenience of having an in-home washer and dryer, as well as reserved and covered parking. Take advantage of our coffee bar for a relaxing break or join others in the outdoor play area. Experience community-focused living with just the right amount of privacy at FLATZ 480 in San Tan Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments – San Tan Valley 85140",
      "seo_description": "Live comfortably in FLATZ 480's 1 bedroom apartments in San Tan Valley 85140 with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "two-bedroom-rental-pinal-county",
      "search_query": "two bedroom rental pinal county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in Pinal County",
      "h2_subtitle": "Discover spacious two bedroom rentals at FLATZ 480, located in the heart of Pinal County, San Tan Valley, offering modern amenities for all residents.",
      "page_copy": "Experience the ideal home at FLATZ 480, featuring expansive two bedroom rentals that offer ample space and dynamic living in Pinal County. Located in the beautiful San Tan Valley, these residences are perfect for families or roommates who appreciate a combination of contemporary style and comfort.\n\nBeyond the spacious interiors, FLATZ 480 boasts an array of amenities designed to enrich our residents' lifestyles. Enjoy the convenience of an in-home washer and dryer, take advantage of our reserved and covered parking, or engage in friendly games on our pickleball court. These features make FLATZ 480 a prime choice for those seeking two bedroom residences in Pinal County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals – Pinal County",
      "seo_description": "Explore spacious two bedroom rentals at FLATZ 480 in Pinal County, San Tan Valley. Modern living with impressive amenities awaits you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "three-bedroom-flats-arizona",
      "search_query": "three bedroom flats arizona",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Flats in Arizona",
      "h2_subtitle": "Discover stunning three bedroom flats at FLATZ 480, nestled in Arizona's vibrant San Tan Valley, offering family-friendly features and amenities.",
      "page_copy": "FLATZ 480 is proud to offer exceptional three bedroom flats in Arizona's San Tan Valley, designed with families and those seeking additional space in mind. Our flats provide ample room for everyone, featuring modern designs and high-end finishes that create a welcoming and stylish living environment.\n\nResidents can enjoy various luxurious amenities such as in-home washers and dryers, reserved and covered parking, and an engaging outdoor play area for children. The coffee bar and pickleball court offer recreational options right at your doorstep. Choose FLATZ 480 for a balanced lifestyle with everything today's modern family could desire in Arizona.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Flats – Arizona",
      "seo_description": "Check out FLATZ 480's three bedroom flats in Arizona's San Tan Valley, featuring roominess, comfort, and exciting amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "apartments-near-frontier-family-park",
      "search_query": "apartments near Frontier Family Park San Tan Valley",
      "category": "Park",
      "h1_title": "Apartments Near Frontier Family Park",
      "h2_subtitle": "Discover ideal living at FLATZ 480, conveniently located near the charming Frontier Family Park in San Tan Valley.",
      "page_copy": "Finding a home close to great leisure spots is easy with FLATZ 480, perfectly situated near Frontier Family Park in San Tan Valley. Whether you're looking to enjoy a peaceful retreat or an action-packed day with family, our apartments offer unmatched convenience and comfort.\n\nAt FLATZ 480, residents benefit from thoughtfully curated amenities including an in-home washer and dryer, reserved and covered parking, and a lively on-site coffee bar. For the sports enthusiasts, our pickleball court offers a fun way to stay active. Additionally, our outdoor play area is a perfect spot for families to unwind. Enjoy the best of both community and nature living at FLATZ 480.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Frontier Family Park",
      "seo_description": "Live conveniently at FLATZ 480, near Frontier Family Park in San Tan Valley. Enjoy modern amenities and comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "mansel-park-nearby-stv-apartments",
      "search_query": "Mansel Park nearby San Tan Valley AZ apartments",
      "category": "Park",
      "h1_title": "Mansel Park Nearby Apartments",
      "h2_subtitle": "Explore the vibrant lifestyle at FLATZ 480, where Mansel Park is just a short distance from these San Tan Valley, AZ apartments.",
      "page_copy": "FLATZ 480 offers the perfect blend of convenience and tranquility, situated near the picturesque Mansel Park in San Tan Valley, AZ. Enjoy easy access to lush green spaces while savoring the comfort of our modern apartment community.\n\nOur residents at FLATZ 480 relish in-home perks like washers and dryers and reserved, covered parking spaces that add convenience to daily life. The community features a welcoming coffee bar for leisurely mornings and a pickleball court for active afternoons. Families and pet owners will love the outdoor play areas, ensuring entertainment and relaxation are always within reach. Choose FLATZ 480 as your home near Mansel Park and experience unmatched living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mansel Park in San Tan Valley",
      "seo_description": "Discover FLATZ 480 apartments near Mansel Park, San Tan Valley, AZ. Enjoy modern living with lush green spaces and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "desert-mountain-park-85140-apartments",
      "search_query": "Desert Mountain Park close to 85140 apartments",
      "category": "Park",
      "h1_title": "85140 Apartments Near Desert Mountain Park",
      "h2_subtitle": "Experience exceptional living at FLATZ 480, conveniently located near the scenic Desert Mountain Park, close to zip code 85140.",
      "page_copy": "Nestled in the heart of San Tan Valley, FLATZ 480 offers premium apartment living just moments away from Desert Mountain Park. Residents enjoy the serenity of nearby nature trails while benefiting from the convenience of modern amenities, making it an ideal choice for outdoor enthusiasts and active families alike.\n\nOur community features an array of comforts including in-home washers and dryers, reserved and covered parking, and inviting spaces like a coffee bar and pickleball court. Children and pets alike will love our outdoor play area, perfect for family fun. FLATZ 480 provides a seamless blend of indoor luxury and outdoor adventure, all within reach of zip code 85140 and Desert Mountain Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Desert Mountain Park, 85140",
      "seo_description": "Live at FLATZ 480 near Desert Mountain Park, close to 85140. Modern amenities and scenic views create a perfect home in San Tan Valley.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162477",
      "property_id": "6767906449167811",
      "source": "generator",
      "page_item_url": "apartments-near-qc-botanical-gardens",
      "search_query": "apartments near Queen Creek Botanical Gardens Pinal County",
      "category": "Park",
      "h1_title": "Apartments Near Queen Creek Botanical Gardens",
      "h2_subtitle": "FLATZ 480 offers stylish living near the Queen Creek Botanical Gardens, located in scenic Pinal County.",
      "page_copy": "For nature lovers and those seeking tranquil living in Pinal County, FLATZ 480 is perfectly positioned near the serene Queen Creek Botanical Gardens. Our community ensures you stay connected with nature while enjoying all the comforts of a modern home.\n\nResidents at FLATZ 480 benefit from an array of premium amenities including in-home washers and dryers, reserved and covered parking, and a welcoming coffee bar. Engage in a game of pickleball or relax in the outdoor play area, perfect for families and friends. Embrace a balanced lifestyle with easy access to beautiful botanical gardens and convenient urban amenities, making FLATZ 480 a unique place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Queen Creek Botanical Gardens",
      "seo_description": "Discover FLATZ 480 near Queen Creek Botanical Gardens in Pinal County. Enjoy modern apartments with easy access to nature and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "13230439117"
    },
    {
      "ID": "custom_fenix_chatbot",
      "type": "STRING",
      "value": "32459"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KX79PG4H"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Avenue"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "58853813423"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/dqw9d2l3vo9"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "520-317-7955"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjJvZ1hkb3N3RmRvTVFOVjU5MjFhdWc9PSIsInZhbHVlIjoiVS84RjAzeGtUd3BocWVaeTZhV0VFUT09IiwibWFjIjoiYTRmODA2OTQ4YjZkZDMzZjM3ODNhZTJmNDBmZWZjM2YwOTY4NzQ3NDUyZjcwZjcyOWMwNzIzOGQwMWQxZjQ1ZiJ9"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_repli_id": "13230439117",
  "custom_fenix_chatbot": "32459",
  "custom_google_gtm_id": "GTM-KX79PG4H",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Avenue",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "58853813423",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/dqw9d2l3vo9",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "520-317-7955",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjJvZ1hkb3N3RmRvTVFOVjU5MjFhdWc9PSIsInZhbHVlIjoiVS84RjAzeGtUd3BocWVaeTZhV0VFUT09IiwibWFjIjoiYTRmODA2OTQ4YjZkZDMzZjM3ODNhZTJmNDBmZWZjM2YwOTY4NzQ3NDUyZjcwZjcyOWMwNzIzOGQwMWQxZjQ1ZiJ9",
  "custom_audioeye_site_id": "a47b3deb-3794-4846-adfb-983b827688b1",
  "custom_audioeye_site_hash": "d80f797930cd979d77c7a76b01325026"
};

export const generatedAt = '2026-11-03T18:40:01.244Z';
